import React from "react"

import { connect } from 'react-redux';

import {
    Card, CardBlock, CardTitle,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,
    ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
    Input,
    Badge,
    Row,Modal, ModalHeader, ModalBody, ModalFooter,Tooltip ,Label,FormGroup,
} from 'reactstrap';

import { TabContent, TabPane, Nav, NavItem, NavLink, CardText, Col } from 'reactstrap';
import classnames from 'classnames';

import lodash from "lodash";

import { Redirect, Link } from 'react-router-dom';
/*editor*/
import { convertFromHTML, EditorState, ContentState } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import Select, {Async} from 'react-select';
import 'react-select/dist/react-select.css';
import ReactTable from "react-table";
import "react-table/react-table.css";

import moment from 'moment';

import _ from 'underscore';

import swal from 'sweetalert2';



import FAchevronleft from 'react-icons/lib/fa/chevron-left';
import FAfloppyO from 'react-icons/lib/fa/floppy-o';
import FAdollar from 'react-icons/lib/fa/dollar';
import FAban from 'react-icons/lib/fa/ban';
import FAprint from 'react-icons/lib/fa/print';
import FaFac from 'react-icons/lib/fa/file-text';
import FaEdit from 'react-icons/lib/fa/edit';
import FaEnvelopeO from 'react-icons/lib/fa/envelope-o';
import FaCel from 'react-icons/lib/fa/phone';
import IconEdit from 'react-icons/lib/md/edit';
import IconNote from 'react-icons/lib/md/check-circle';
import IconRetorno from 'react-icons/lib/md/reply-all';
import IconNoAprobado from 'react-icons/lib/fa/file-excel-o';
import IconFacturaRemision from 'react-icons/lib/fa/file-o';


import Icono_facturar  from "react-icons/lib/md/check-circle";



import IconInfo from 'react-icons/lib/fa/info-circle';
import { FaPlus,FaUndo } from "react-icons/lib/fa";



import * as actions from '../../actions/ticket';
import VentaModal from '../../components/modal';
import ClienteModal from '../clientes/Modal';
import EstadoModal from '../../components/cliente/llamarCliente';
import ModalTablas from '../../components/catalogos/modal_tablas';
import Articulo from "../inventario/Modal";

import ModalFactura from '../../components/facturarTicket/ModalFactura';
import ModalCorreo from '../../components/facturarTicket/ModalCorreo';
import ArticulosCombo from '../../components/articulosCombo';

import {api, request, API_URL} from '../../actions/_request';

const tipos = [
	{label: 'Tienda', value: 1},
	{label: 'Sitio', value: 2},
	{label: 'Remoto', value: 3},
	{label: 'Venta', value: 4}
];
const tipos_productos = [
	{label: 'No Aplica', value: 0},
];
const tipos_precios = [
	{label: 'Contado', value: 0},
	{label: 'Credito', value: 1},	
];
const tipos_contpaq = [
	{label: 'Paquete', value: 1},
	{label: 'Actualizacion', value: 2},
	{label: 'Cambio Caract.', value: 3}
];

const departamentost = [
	{label: 'Ventas', value: 1},
	{label: 'Contpaq', value: 2},
	{label: 'Remanufacturado', value: 3},
	{label: 'Tecnico', value: 4},
	{label: 'Instalaciones', value: 5}
];

const asistencias = [
	{label: 'PC', value: 1},
	{label: 'Laptop', value: 2},
	{label: 'Dispositivo Movil', value: 3},
	{label: 'Impresora', value: 4},
	{label: 'Toner', value: 5},
	{label: 'Cartucho', value: 6},
	{label: 'Instalaciones', value: 7},
	
];

const servicios_contpaq = [
	{label: 'Instalaciones', value: 7},//1
	{label: 'Capacitaciones', value: 8},//2
	{label: 'Soporte', value: 9},//3
	{label: 'Rebate', value: 10}	//4
];

const ventas = [
	{label: 'Computadora Outlet', value: 1},
	{label: 'Computadora', value: 2},
	{label: 'Cpu Outlet', value: 3},
	{label: 'Cpu', value: 4},
	{label: 'RM' , value : 5},
	{label: 'soluciones diversas', value : 6},
	{label: 'Sistemas de Vigilancia', value: 7},
	{label: 'Licenciamiento de Software', value: 8},
	{label: 'Accesorios', value: 9},
	{label: 'Otros', value: 10},
];

const procesos = [
	{label: 'Inicio', value: 1},
	{label: 'Proceso', value: 2},
	{label: 'Finalizado', value: 3},
	{label: 'Cancelado', value: 4},
	{label: 'Garantia', value : 5}
];

const estadoCliente =[
         'success',
         'warning',
         'danger',
         'secondary'
    ];

    const descuentos = [
    {label: '0%', value: 0},
    {label: '5%', value: 5},
    {label: '10%', value: 10},
    {label: '15%', value : 15},
    {label: '20%', value : 20}
];

const estados_compra = [
    {label: 'Pendiente', value: 0},
	{label: 'Comprado al Proveedor', value: 1},
	{label: 'En Transito al Storage', value: 2},
	{label: 'En Storage', value: 3},
	{label: 'En Transito a Maxicomm', value: 4},
	{label: 'Recibido En Maxicomm', value: 5},
	{label: 'Cancelado', value: 6},
];

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };
class TicketForm extends React.Component {

	constructor(props) {

		super(props)
		// console.log('id usuario--->',parseInt(this.props.auth.user.id));

		this.state = {
			ticket: {
				fecha_ticket: moment().format('Y-MM-DD'),
				hora_ticket: moment().format('HH:mm'),
				tipo_id: 1,
				precio: 0,
				fecha_cita: moment().format('Y-MM-DD'),
				hora_cita: moment().format('HH:mm'),
				
				asistencia_id: null,
				cliente_id: null,
				descripcion: '',
				descripcion_proceso: '',
				descripcion_finalizado: '',
				usuario_id: parseInt(this.props.auth.user.id),
				proceso_id: 1,
				id: 0,
				proceso_id : 1,
				tipo_pago : 1,
				costo : 0,
				incremento : 0,
				descuento : 0,
				estado : 4,
				tipo_precios:0,
				anticipo:0.00,
				fecha_anticipo:null,
				pagado:0,
				pv:0,

				
				total:0,
				iva:0,
				subtotal:0,
				pagado:0,
				items : [],
			},
			items: [],
			editorState: null,
			cliente: null,
			modal : false,
			modalCliente : false,
			cliente_id : null,
            title       : "",
			modalEstado : false,
			edit : false,
			action : 'pagar',
			dropdownOpen: false,
			showSign: true,
			departamentos:[],
			llamadas:[],
			rows:[],
			paquetes:0,
			total:0,
			subtotal:0,
			iva:0,
			index:0,
			modal_descripcion:false,
			usuarios:[],
			modal_factura:false,
			modal_correo:false,
			factura:[],
			activeTab: '1',
			compras:[],
			descripcion_compra:'',
			reset:false,
			
		};

		this.handleInputChange 		= this.handleInputChange.bind(this);
		this.handleSelectChange 	= this.handleSelectChange.bind(this);
		this.getClients 			= this.getClients.bind(this);
		this.handleChangeEditor 	= this.handleChangeEditor.bind(this);
		this.toggle					= this.toggle.bind(this);
		this.toggle_cliente 		= this.toggle_cliente.bind(this);
		this.toggle_estado			= this.toggle_estado.bind(this);
		this.factura 				= this.factura.bind(this);
		this.submit 				= this.submit.bind(this);
		this.pay 					= this.pay.bind(this);
		this.getticket 			    = this.getticket.bind(this);
		this.cancel 				= this.cancel.bind(this);
		this.toggle_dropdownOpen 	= this.toggle_dropdownOpen.bind(this);
		this.updatecampos 				= this.updatecampos.bind(this);
		this.addRow 				= this.addRow.bind(this);
		this.deleteRow 				= this.deleteRow.bind(this);
		this.sacar_total 				= this.sacar_total.bind(this);
		this.modal_descripcion 				= this.modal_descripcion.bind(this);
	    this.handleChangedescripcion 				= this.handleChangedescripcion.bind(this);
	    this.imprimir_pago 				= this.imprimir_pago.bind(this);
	    this.sacar_productos_suite 				= this.sacar_productos_suite.bind(this);
	    this.cambiar_total 				= this.cambiar_total.bind(this);
	    this.pagar_credito 				= this.pagar_credito.bind(this);
	    this.get_cliente 				= this.get_cliente.bind(this);
	    this.restauracion 				= this.restauracion.bind(this);
	    this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);
        this.toggle_factura= this.toggle_factura.bind(this); 
        this.toggle_correo= this.toggle_correo.bind(this);

        this.remisionar= this.remisionar.bind(this);
	    this.toggle_tab= this.toggle_tab.bind(this);
	    this.agregar_compras= this.agregar_compras.bind(this);
	    this.recargar_compras= this.recargar_compras.bind(this);
	    this.handleInputChangeState= this.handleInputChangeState.bind(this);
	    this.cancelar_compra= this.cancelar_compra.bind(this);
	    this.imprimir_anticipo= this.imprimir_anticipo.bind(this);
	    this.firma= this.firma.bind(this);
	    this.no_aprobado= this.no_aprobado.bind(this);


	    this.actualizar_articulos= this.actualizar_articulos.bind(this);
        this.recargar2 = this.recargar2.bind(this);

	    
	}
	recargar2(){
        this.setState({
          reset:false,
      });
    }
   actualizar_articulos(precio,combo,costo,opcion=1){

      var rows = this.state.rows;
	  var index = this.state.index;
	  let paquetes=parseInt( this.state.paquetes);
	  let ticket = this.state.ticket;
	  if(opcion==1){
	  	 rows[index].precio = precio;
	  	 rows[index].costo = costo;
	  	  rows[index].combo = combo;
	  }
	 
	 
	  
      this.sacar_total(parseInt(ticket.tipo_precios),rows,paquetes,false);

    }
	firma(opcion){
		const {params} = this.props.match;
		//tickets/firma_noAprobado
		if(opcion==1){
			this.props.history.push('/tickets/term/'+params.id);
		}
		if(opcion==2){
			this.props.history.push('/tickets/firma_finalizado/'+params.id);
		}
		if(opcion==3){
			this.props.history.push('/tickets/firma_noAprobado/'+params.id);
		}
		
	}

	imprimir_anticipo(){
		let ticket = this.state.ticket;		
	     let self = this;
	     let min = parseFloat( ticket.anticipo_min);
	     let bandera = true;

	      if(parseFloat(ticket.anticipo)<min){
	      	swal('Error', 'Anticipo minimo es de '+this.formateo(min),'error');
	      	return
	      }

	     if(ticket.fecha_anticipo!=null){
	     	 window.open(API_URL+"/ticketsv2/printAnticipo/"+ticket.id);
	     }else{
	     	swal({
		  title: 'Estas seguro?',
		  text: "De Imprimir recibo de Anticipo por "+this.formateo(ticket.anticipo)+" ya  no se podra cambiar ",
		  type: 'warning',
		  showCancelButton: true,
		  confirmButtonColor: '#3085d6',
		  cancelButtonColor: '#d33',
		  confirmButtonText: 'Estoy Seguro!',
		   cancelButtonText: 'Cancelar!'
			}).then((result) => {
				if (result.value) {
					api().get('/agregar_anticipo/'+ticket.id+'/'+ticket.anticipo)
		            .then(function(response)
		            {    
		                   
		                if(response.status === 200)
		                {   
		                   if(response.data.estado){
		 						
		 						
					        	ticket.fecha_anticipo=response.data.fecha;
			                   	self.setState({
			                   		ticket:ticket,
					            });
					            window.open(API_URL+"/ticketsv2/printAnticipo/"+ticket.id);


		                   }else{
		                    // console.log('Mensaje de error--->',response.data.mensaje);
		                    swal.insertQueueStep({
		                        type: 'error',
		                        title: response.data.mensaje
		                      })

		                   }
		                  
		                }
		            })
		            .catch(() => {
		              swal.insertQueueStep({
		                type: 'error',
		                title: 'Solicitar ayuda a un Administrador'
		              })
		            });

				}
			});

	     }
	      

	}
	cancelar_compra( compra ){

		 let ticket = this.state.ticket;		
	     let self = this;

	 swal({
		  title: 'Estas seguro?',
		  text: "De Cancelar la Compra especial!",
		  type: 'warning',
		  showCancelButton: true,
		  confirmButtonColor: '#3085d6',
		  cancelButtonColor: '#d33',
		  confirmButtonText: 'Estoy Seguro!',
		   cancelButtonText: 'Cancelar!'
		}).then((result) => {
		  if (result.value) {

		api().post('/cancelar_compra_especial/'+compra.id,compra)
	            .then(function(response)
	            {    
	                   
	                if(response.status === 200)
	                {   
	                   if(response.data.estado){
	 						// console.log('estado-->',response.data.estado);
	 						let total=0;
				        	for (var i = response.data.compras.length - 1; i >= 0; i--) {
				        		if(parseInt( response.data.compras[i].estado)<6)
				        		total+=parseFloat( response.data.compras[i].anticipo);
				        	}
				        	ticket.anticipo_min=total;
		                   	self.setState({
		                   		ticket:ticket,
				                 compras : response.data.compras
				            });
			                 self.props.alerta({
					            mensaje:"Compra Especial Cancelada Correctamente",
					            tipo:"success",
					            creacion:moment().format('Y-MM-DD H:m:s'),
					          });
	                   }else{
	                    // console.log('Mensaje de error--->',response.data.mensaje);
	                    swal.insertQueueStep({
	                        type: 'error',
	                        title: response.data.mensaje
	                      })

	                   }
	                  
	                }
	            })
	            .catch(() => {
	              swal.insertQueueStep({
	                type: 'error',
	                title: 'Solicitar ayuda a un Administrador'
	              })
	            });


		}
	})


	}



	handleInputChangeState(event) {

		if(event === null) return;

		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;


		this.setState({
				[name]: value
			
		});

	}
	recargar_compras(){

		let ticket = this.state.ticket;		
	    let self = this;

		api().get('/compras_especiales_ticket/'+ticket.id)
        .then(function(response)
        {  let total=0;
        	for (var i = response.data.length - 1; i >= 0; i--) {
        		if(parseInt( response.data[i].estado)<6)
        		total+=parseFloat( response.data[i].anticipo);
        	}
        	ticket.anticipo_min=total;
            self.setState({
            	ticket:ticket,
                compras : response.data,
            });
            
    
           
        });

	}
	agregar_compras(){
		let texto=this.state.descripcion_compra;
		if(texto.length >0 ){

			swal({
			  title: 'Estas seguro?',
			  text: "Se agregara a la lista De Compras especiales!",
			  type: 'warning',
			  showCancelButton: true,
			  confirmButtonColor: '#3085d6',
			  cancelButtonColor: '#d33',
			  confirmButtonText: 'Estoy Seguro!',
			   cancelButtonText: 'Cancelar!'
			}).then((result) => {
			  if (result.value) {
			  	
		       let ticket = this.state.ticket;		
			   let self = this;
			   let compra={
			   	ticket_id:ticket.id,
			   	estado:0,
			   	descripcion:this.state.descripcion_compra,
			   	precio: this.state.precio_compra,
			   	nota:'',
			   };

			   this.props.save_compra(compra, (response) => {
				
				if(response.estado){
 						// console.log('response-->',response) 
 						let total=0;
			        	for (var i = response.compras.length - 1; i >= 0; i--) {
			        		if(parseInt( response.compras[i].estado)<6)
			        		total+=parseFloat( response.compras[i].anticipo);
			        	}
			        	ticket.anticipo_min=total;
	                   	self.setState({
	                   		ticket:ticket,
	                   		descripcion_compra:'',
	                   		precio_compra:0,
			                compras : response.compras,
			            });

                 
		                 self.props.alerta({
				            mensaje:"Compra Especial Registrada Correctamente",
				            tipo:"success",
				            creacion:moment().format('Y-MM-DD H:m:s'),
				          });


                   }else{
                    // console.log('Mensaje de error--->',response.mensaje)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.mensaje
                      })

               }

			});			    
			  }
			})

		}else{
				swal('Error', 'Descripcion Vacia','error');
		}


		


		


	}
	toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }
	remisionar(){
         let {ticket} = this.state;
         let self =this;
		 swal.queue([{
        title: 'Estas seguro?',
        text: "De Remisionar el ticket",
        input: 'select',
		inputOptions :
		{
			0 : 'Contado',
			1	: 'Credito'
		},
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: (opcion) => {
          return api().post('/remisionar_ticket/'+ticket.id+'/'+opcion)
            .then(function(response)
            {    
                   
                if(response.status === 200)
                {   
                   if(response.data.estado){
 						// console.log('estado-->',response.data.estado) 
                   	self.setState({
		                ticket : response.data.ticket
		            });

                 
                 self.props.alerta({
		            mensaje:"Ticket Remisionado Correctamente",
		            tipo:"success",
		            creacion:moment().format('Y-MM-DD H:m:s'),
		          });


                   }else{
                    // console.log('Mensaje de error--->',response.data.mensaje)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.mensaje
                      })

                   }
                  
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador'
              })
            })
        }
      }]);

	}
	

	toggle_factura(){  

        this.setState({
            modal_factura : !this.state.modal_factura,         
        })
    }

    toggle_correo(opcion=0,factura=[],ticket=[]){ 

    	if(opcion==1){
    		// console.log('opcion 1')
    		// // console.log('modal correo---->',!this.state.modal_correo)
    		// console.log('ticket--->',ticket);
    		this.setState({
    			modal_correo : !this.state.modal_correo, 
            	modal_factura : !this.state.modal_factura,
            	factura : factura.id,
                ticket:ticket,

       		})
       		// console.log('state--->',this.state);

    	}else{
    		// console.log('opcion 0')
    		this.setState({
            	modal_correo : !this.state.modal_correo,         
        	})
    	}

        
    }

	 retorno(objeto,campo,vacio=0,valor=""){
       // console.log('renglon---->',objeto);
        
        let self =this;
        let id=objeto.value?objeto.value:objeto.id;
        api().get('/inventario')
        .then(function(response)
        {
            self.setState({
                items : response.data
            });
            self.addRow(id);
            self.toggle_modal();
           
        });
        

    }
    toggle_modal(index=26,catalogo="",campo=""){  

        this.setState({
            modal_articulo : !this.state.modal_articulo,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }

	


	componentDidMount() {

		let self = this;
		const {params} = this.props.match;
 		api().get('/departamentos')
        .then(function(response)
        {
            self.setState({
                departamentos : response.data
            });
         
           
        });
        api().get('/select/users')
        .then(function(response)
        {
            self.setState({
                usuarios : response.data
            });
         
           
        });

        api().get('/inventario')
        .then(function(response)
        {
            self.setState({
                items : response.data
            });
            
           
        });

       
		if(params.id) {
			 self.props.get_llamadas(params.id);

			api().get('/ticketsv2/'+params.id).then((response) => {

				if(response.status === 200) {

					let data = response.data;

					self.cliente = data.cliente;
					self.cliente.tipo = data.tipo;
					let ticket=data.ticket;
				
					 api().get('/listaticket/'+params.id)
			        .then(function(response)
			        {
			            self.setState({
			                rows : response.data
			            });
			            self.sacar_productos_suite(response.data);
			            ////////console.log(response)
			            api().get('/compras_especiales_ticket/'+params.id)
				        .then(function(response)
				        {
				        	let total=0;
				        	for (var i = response.data.length - 1; i >= 0; i--) {
				        		if(parseInt( response.data[i].estado)<6)
				        		total+=parseFloat( response.data[i].anticipo);
				        	}
				        	ticket.anticipo_min=total;
				            self.setState({
				                compras : response.data,
				                ticket: ticket,
				                edit : true,
				            });
				            
				    
				           
				        });
			           
			        });
				}

			});

			///llamarcliente/{ticketid}
			


		}
		else {
			self.setState({ editorState: EditorState.createEmpty() });
		}

	}

	imprimir_pago()
	{

		let self = this;
		const {params} = this.props.match;
		api().get('/ticketsv2/'+params.id).then((response) => {
				if(response.status === 200) {
					let data = response.data.ticket;
					if(parseInt( data.pagado)>0){
						 window.open(API_URL+"/ticketsv2/printTicketFinal/"+data.id);
					}else{
						 swal('Error', 'El ticket no esta pagado','error');
					}	
				}
			});		
	}

	validacion_incremento(precio,costo,incremento){

       
         var utilidad=precio-costo;
         // console.log("utilidad: " +utilidad);
	     var porcentaje=(utilidad/costo)*100;
	     // console.log("porcentaje utilidad: " +porcentaje);
	     var bandera=true;
	     var porcentaje_incremento=(incremento/precio)*100;
	     // console.log("porcentaje incremento: " +porcentaje_incremento);
	     if(incremento==0){
	     	// console.log("bandera: " +bandera);
	     		// console.log("incremento 0 ");
               return bandera;
	     }

		if(parseInt(precio,10)>20000)
		{
			if(porcentaje>=20)
			{
				if(porcentaje_incremento<=5)
				{

				}else{
					bandera=false; 
				}
			}else{
				bandera=false; 
				
			}

		}else
		{
			if(parseInt(precio,10)<=20000&&parseInt(precio,10)>15000)
			{
				if(porcentaje>=22)
				{
					if(porcentaje_incremento<=5)
					{

					}else{
						bandera=false; 
						
					}
				}else{
					bandera=false; 
					
				}
			}else
				{
					if(parseInt(precio,10)<=15000&&parseInt(precio,10)>5000)
					{
						if(porcentaje>=32) 
						{

							if(parseInt(precio,10)>14000){
								if(porcentaje_incremento<=5)
								{

								}else{
									bandera=false; 
									
								}

							}else{

								if(parseInt(precio,10)>7000){
									if(porcentaje_incremento<=7)
									{

									}else{
										bandera=false; 
										
									}

								}else{
									if(porcentaje_incremento<=10)
									{

									}else{
										bandera=false; 
										
									}

								}

							}
						}else{
							bandera=false; 
							
						}
					}else
					{

						if(parseInt(precio,10)<=5000&&parseInt(precio,10)>2000)
						{
							
							if(porcentaje>=40)
							{
								if(porcentaje_incremento<=10)
								{

								}else{
									bandera=false; 
									
								}
							}else{
								bandera=false; 
								
							}
						}else
						{
							
						}
						
					}	
					
				}		
		}/*fin del else principal*/
      // console.log("bandera: " +bandera);
      return bandera;
	}

	addRow(id) {

		var rows = this.state.rows;
		let paquetes=parseInt( this.state.paquetes);
		let ticket = this.state.ticket;
		let self =this;

		api().get('/inventario/solo/'+id+'?cliente='+this.state.ticket.cliente_id)
	        .then(function(response)
	        {	  

	        	 let uno =0;
	        	 let precio=0;
	        	 let total_articulo=0;
	        	 let descripcion='';
	                 if(parseInt(ticket.tipo_precios)==0){
	                 //	console.log("contado");
	                 	 uno = parseFloat(response.data.contado)/100;
	                 	 precio=parseFloat(response.data.contado);

	                 }else{
	                 //	console.log("credito");
	                 	 uno = parseFloat(response.data.credito)/100;
	                 	 precio=parseFloat(response.data.credito);
	                 }
	                
	                 let total=uno*(100+parseFloat(response.data.iva));
	                 total_articulo=total.toFixed(2);

	                 if(parseInt(response.data.categoria_id)!==10)
	                  descripcion=response.data.nombre;
	                 

			        rows.unshift({
						costo:parseFloat(response.data.costo),
						descuento:0,
						descuento_adicional:0,
						incremento:0,
						ultimo_precio:response.data.ultimo_precio,
						inventario_id:id,
						precio:precio,
						tipo_id:0,
						value:0,
						total:total_articulo,
						cantidad:1,
						descripcion:descripcion,
						producto:response.data,
						iva:parseFloat(response.data.iva),
						pago_comision:0,
						fecha_pago_comision:null,
						combo_id:response.data.combo_id,
						combo:response.data.combo,
					});    
					// console.log("productos----->",rows);     
	        	
	                 // rows[index].producto= response.data;	                
	                 // rows[index].costo=parseFloat(response.data.costo);	             
	                 // rows[index].incremento=0;
	                 // rows[index].ultimo_precio=response.data.ultimo_precio;	
	                
	                // // console.log(response.data);


	             
		               
				    	self.sacar_total(parseInt(ticket.tipo_precios),rows,paquetes);
	        });  
	}
	modal_descripcion(index=0){
		

		this.setState({
			modal_descripcion : !this.state.modal_descripcion,
			index:index
		})
	}
	handleChangedescripcion(event)
	{
		const target 	= event.target;
		const value 	= target.type === 'checkbox' ? target.checked : target.value;
		const name 		= target.name;

		var rows = this.state.rows;
		var index = this.state.index;
		rows[index][name] = value;
		this.setState({rows: rows});
  

	}

	deleteRow(index) {
		swal({
			  title: 'Estas seguro?',
			  text: "Se eliminara  el producto de la lista!",
			  type: 'warning',
			  showCancelButton: true,
			  confirmButtonColor: '#3085d6',
			  cancelButtonColor: '#d33',
			  confirmButtonText: 'Estoy Seguro!',
			   cancelButtonText: 'Cancelar!'
			}).then((result) => {
			  if (result.value) {
			  	var rows = this.state.rows;
			let rows = this.state.rows;
		let cliente=this.cliente;
		let paquetes=parseInt( this.state.paquetes);
		let ticket = this.state.ticket;
			let paq=paquetes;
			let self = this;
	    	
	    	
			    	if(parseInt( rows[index].producto.categoria_id)===8&&parseInt(rows[index].tipo_id)!==3&&parseInt( rows[index].producto.descuento_suite,10)>0)
			    	{
			    		
			    		// console.log("restar")
			    		// console.log("categoria:"+parseInt( rows[index].producto.categoria_id))
			    		// console.log("tipo id:"+parseInt( rows[index].tipo_id))
			    		paq=parseInt(paquetes)-(parseInt(rows[index].cantidad));
			    		
			    	}
			    	
					rows.splice(index, 1);
					this.setState({
									rows: rows,
						    		paquetes: paq
						    	});

					this.sacar_total(parseInt(ticket.tipo_precios),rows,paq);


			    swal(
			      'Producto!',
			      'Se elimino de la lista.',
			      'success'
			    )
			  }
			})
}
	

	updatecampos(val, index,campo) {
		let rows = this.state.rows;
		let cliente=this.cliente;
		let paquetes=parseInt( this.state.paquetes);
		let ticket = this.state.ticket;
		////////console.log(cliente);
        let anterior =rows[index][campo];
		rows[index][campo] = val;
	
		// console.log(campo);
		// console.log(rows[index][campo]);
		let bandera=true;
		
		switch(campo)
		{
			
			case "total":
				bandera=false;			
			break;

			case "cantidad":
			let vacio=false;
			if(val===''){
		    			vacio=true;
                        val=anterior;
		    			//////console.log("zzzzzzzz");
		    		}
						var cantidad=parseInt(val,10);
						var final=0;
							
								if(parseInt( rows[index].producto.categoria_id)===8&&parseInt(rows[index].tipo_id)!==3&&parseInt( rows[index].producto.descuento_suite,10)>0)
			       				{
			       					if(vacio){
			       						 //////console.log(parseInt(rows[index].tipo_id));
									let diferencia= parseInt(anterior);
									paquetes= paquetes+diferencia;
									//////console.log("paquetes: "+paquetes );

			       					}else{
			       						 //////console.log(parseInt(rows[index].tipo_id));
									let diferencia=cantidad- parseInt(  anterior);
									paquetes= paquetes+diferencia;
									//////console.log("paquetes: "+paquetes );
			       					}
                                   
							    }
								
					
						

			break;			
			case "tipo_id":			
			if(parseInt(val)!==3){
				
				let self = this;
				let paq=parseInt(paquetes);
				/*validamos  si el producto tiene suite para que incremente la bandera paquetes*/
				if(parseInt( rows[index].producto.descuento_suite,10)>0){
					paq++;
					// console.log("incrementa");
				}else{
					// console.log("no incrementa");
				}
				paquetes=paq;
			}	 		
			break;	
			
			case "inventario_id":			
			let self = this;
	 		api().get('/inventario/solo/'+val+'?cliente='+this.state.ticket.cliente_id)
	        .then(function(response)
	        {	           
	        	     alert("entro  aqui");
	                 rows[index].producto= response.data;	                
	                 rows[index].costo=parseFloat(response.data.costo);	             
	                 rows[index].incremento=0;
	                 rows[index].ultimo_precio=response.data.ultimo_precio;	
	                 let uno =0;
	                 if(parseInt(ticket.tipo_precios)==0){
	                 //	console.log("contado");
	                 	 uno = parseFloat(response.data.contado)/100;
	                 	 rows[index].precio=parseFloat(response.data.contado);

	                 }else{
	                 //	console.log("credito");
	                 	 uno = parseFloat(response.data.credito)/100;
	                 	 rows[index].precio=parseFloat(response.data.credito);
	                 }
	                
	                 let total=uno*116;
	                 rows[index].total=total.toFixed(2);

	                 if(parseInt(response.data.categoria_id)!==10){
	                  rows[index].descripcion=response.data.nombre;
	                 }else{rows[index].descripcion="";}
	                // console.log(response.data);


	             
		               
				    	self.sacar_total(parseInt(ticket.tipo_precios),rows,paquetes);
	        });    		
			break;
			default:
			

			break

		}
		// console.log(rows);
		if(bandera){
			// console.log('sacar total')
			this.sacar_total(parseInt(ticket.tipo_precios),rows,paquetes);
		}else{
			console.log('cambiar total')
			this.cambiar_total(parseInt(ticket.tipo_precios),rows,paquetes);
		}
	   
		
    	
    	
	}

	cambiar_total(tipo,lista,paq)
	{
		var rows = lista;
		// console.log(rows);
		let cliente=this.cliente;
		let paquetes=paq;
		let ticket=this.state.ticket;
		ticket.tipo_precios=parseInt(tipo);
		let total=0;
		let iva=0;
		let subtotal=0;		
		 	
    	if(rows.length> 0) 
		{
			
			for (var index = rows.length - 1; index >= 0; index--) 
			{		

		    var cantidad=parseInt(rows[index].cantidad,10);
		    if(isNaN(cantidad)){
		    	cantidad=0;
		    	rows[index].cantidad='';
		    }

			if(parseInt( rows[index].producto.categoria_id)===8)
			{
				       
				         var d_paquete=parseFloat(cliente.tipo.dd_paquete,10);
						var d_actualizacion=parseFloat(cliente.tipo.dd_actualizacion,10);
						var d_cambio=parseFloat(cliente.tipo.dd_caracteristica,10);
						var m_paquete=parseFloat(cliente.tipo.dm_paquete,10);
						var m_actualizacion=parseFloat(cliente.tipo.dm_actualizacion,10);
						var m_cambio=parseFloat(cliente.tipo.dm_caracteristica,10);						
						var x=0;
						var y=0;
						var desc_suite=parseInt( rows[index].producto.descuento_suite,10);
						var bandera=true;
						// if((parseInt( rows[index].producto.descuento_suite,10)!==parseInt( rows[index].descuento_adicional)&&parseInt( rows[index].descuento_adicional)!==0)||parseInt( rows[index].descuento_adicional)!==0){
						// 	desc_suite=parseInt( rows[index].descuento_adicional);

						// 	bandera=true;
						// }
						if((parseInt( rows[index].producto.descuento_suite,10)!==parseInt( rows[index].descuento_adicional))){
							desc_suite=parseInt( rows[index].descuento_adicional);
							bandera=true;
						}
						//console.log("bandera: "+bandera);
						//console.log(desc_suite);

						////////console.log(cliente.tipo)
						if(parseInt(rows[index].tipo_id)===1){
							 x=d_paquete;
							 y=m_paquete;
							 if(paquetes>1){
							 	 rows[index].descuento=(x);
					   			rows[index].descuento_adicional=(desc_suite);
							 }else{
							 	rows[index].descuento=(x);
							 }
							 

						}
						if(parseInt(rows[index].tipo_id)===2){
							 x=d_actualizacion;
							  y=m_actualizacion;
							  if(paquetes>1){
							 	 rows[index].descuento=(x);
					   			rows[index].descuento_adicional=(desc_suite);
							 }else{
							 	rows[index].descuento=(x);
							 }
						}
						if(parseInt(rows[index].tipo_id)===3){
							 x=d_cambio;
							 y=m_cambio;
							 rows[index].descuento=(x);
						}
						
						

						let precio=parseFloat(rows[index].precio);
						//console.log(precio);
						//rows[index].precio=precio.toFixed(2);

						var PL=precio;
						////////console.log("PRECIO: "+PL);
						var DS=((PL/100)*desc_suite);
					//	console.log("DESCUENTO SUITE: "+DS);
						var DD=0;						
						var DM=0;	
						var iva_producto= parseFloat(rows[index].iva,10);									
					if(paquetes>1)
					{ 
					//	console.log("mas de dos");
						////////console.log("PL - DS: "+(PL-DS));
						DD=(((PL-DS)/100)*x);
					//	console.log("DESCUENTO DIST: "+DD);
						 DM=(((PL-DS)/100)*y);
						////////console.log("DESCUENTO MASTER: "+DM);


					    var s=parseFloat(this.trunc((PL-DS-DD),3));
					    var i=s*(iva_producto/100);
				        var i2=parseFloat( this.trunc( i,2));
				        if(cantidad<1){
							i2=0;
						}
					    var t=(s+parseFloat(this.trunc( i,2) ) )*cantidad;							
					    rows[index].total=t.toFixed(2);		
					   rows[index].costo=(PL-DS-DD-DM).toFixed(2);
					   //////console.log(cantidad)
					   rows[index].descuento=(x);
					   rows[index].descuento_adicional=(desc_suite);
				    }
					else
					{   if(bandera){
						// console.log("unitario pero con descuento ");
						////////console.log("PL - DS: "+(PL-DS));
						DD=(((PL-DS)/100)*x);
					//	console.log("DESCUENTO DIST: "+DD);
						 DM=(((PL-DS)/100)*y);
						////////console.log("DESCUENTO MASTER: "+DM);


					   rows[index].costo=(PL-DS-DD-DM).toFixed(2);
					//   console.log("subtotal:" +((PL-DS-DD)*cantidad));
					//   console.log("IVA:" +((PL-DS-DD)*cantidad)*0.16);
						
						
						

						var s=parseFloat(this.trunc((PL-DS-DD),3));
					    var i=s*(iva_producto/100);
				        var i2=parseFloat( this.trunc( i,2));
				        if(cantidad<1){
							i2=0;
						} 
					    var t=(s+parseFloat(this.trunc( i,2) ) )*cantidad;							
					    rows[index].total=t.toFixed(2);		
					   	
					   //////console.log(cantidad)
					   rows[index].descuento=(x);
					   rows[index].descuento_adicional=(desc_suite);

						}
						else{
					    // console.log("uno o menos")
						DD=(((PL)/100)*x);
                        // console.log("DESCUENTO DIST: "+DD);
						DM=(((PL)/100)*y);
						// console.log("DESCUENTO MASTER: "+DM);	
					
					var s=parseFloat(this.trunc((PL-DD),3));
					// console.log("subtotal: "+s);
					var i=s*(iva_producto/100);
			        var i2=parseFloat( this.trunc( i,2));
			        if(cantidad<1){
						i2=0;
					}  
					// console.log("iva: "+this.trunc( i,2));
					var t=(s+parseFloat(this.trunc( i,2) ) )*cantidad;						
					    rows[index].total=t.toFixed(2);							
						rows[index].costo=(PL-DD-DM).toFixed(2);						
					//	console.log((PL-DD))

						}
						
					}
			    

			}else
			{
				     let uno =0;	                 
	                 var iva_producto= parseFloat(rows[index].iva,10);
	                 uno = parseFloat(rows[index].total)/(100+iva_producto);
	                 	
	                 
	                
	                 let precio=(uno*100)/cantidad;
	                 // console.log(precio);
	                 rows[index].precio=this.trunc(precio,2);

				var PL=precio;
				var incremento=parseFloat(rows[index].incremento,10);
				var descuento=parseFloat(rows[index].descuento,10);
				var inc=incremento;
				var desc=(PL/100)*descuento;
				

				// console.log("descuento: "+desc);
				// console.log("incremento: "+incremento);
				var s=parseFloat(((PL+inc-desc)*cantidad).toFixed(3));
				// console.log("sub total: "+s.toFixed(3));

				var i=s*(iva_producto/100);
				var i2=parseFloat( i.toFixed(3));
				// console.log("iva: "+i2)

				var t=s+i2;
				// console.log("total: "+t)
				if(cantidad<1){
					i2=0;
				}

			}

           // console.log('cantidad--->',cantidad);
           rows[index].combo=this.cambiar_precios_combo(rows[index].precio,rows[index].combo);
	        total=parseFloat(total)+ parseFloat(rows[index].total);
	        iva+= i2;
		    subtotal+=total-iva;				    
			}	
        }






       let sub=total-iva;
       // console.log("subtotal Final: "+sub);
	   // console.log("iva final: "+iva);
		ticket.iva=iva.toFixed(2);
		ticket.subtotal=sub.toFixed(2);
		ticket.total=total.toFixed(2);



		this.setState({
				ticket:ticket,
					rows:rows,
					paquetes:paquetes
				
					 });
	}

	cambiar_precios_total(tipo)
	{
		var rows = this.state.rows;
		// console.log(rows);
		let cliente=this.cliente;
		let paquetes=this.state.paquetes;
		let ticket=this.state.ticket;
		ticket.tipo_precios=parseInt(tipo);
		let total=0;
		let iva=0;
		let subtotal=0;		
		let self = this;  	
    	if(rows.length> 0) 
		{
			
			for (var index = rows.length - 1; index >= 0; index--) 
			{		

		    var cantidad=parseInt(rows[index].cantidad,10);
		     if(isNaN(cantidad)){
		    	cantidad=0;
		    	rows[index].cantidad='';
		    }
			if(parseInt( rows[index].producto.categoria_id)===8)
			{
				       
				        var d_paquete=parseFloat(cliente.tipo.dd_paquete,10);
						var d_actualizacion=parseFloat(cliente.tipo.dd_actualizacion,10);
						var d_cambio=parseFloat(cliente.tipo.dd_caracteristica,10);
						var m_paquete=parseFloat(cliente.tipo.dm_paquete,10);
						var m_actualizacion=parseFloat(cliente.tipo.dm_actualizacion,10);
						var m_cambio=parseFloat(cliente.tipo.dm_caracteristica,10);						
						var x=0;
						var y=0;
						var desc_suite=parseInt( rows[index].producto.descuento_suite,10);
						var bandera=false;
						// if((parseInt( rows[index].producto.descuento_suite,10)!==parseInt( rows[index].descuento_adicional)&&parseInt( rows[index].descuento_adicional)!==0)||parseInt( rows[index].descuento_adicional)!==0){
						// 	desc_suite=parseInt( rows[index].descuento_adicional);

						// 	bandera=true;
						// }
						if((parseInt( rows[index].producto.descuento_suite,10)!==parseInt( rows[index].descuento_adicional))){
							desc_suite=parseInt( rows[index].descuento_adicional);
							bandera=true;
						}
						// console.log("bandera: "+bandera);
						// console.log(desc_suite);

						////////console.log(cliente.tipo)
						if(parseInt(rows[index].tipo_id)===1){
							 x=d_paquete;
							 y=m_paquete;
							 if(paquetes>1){
							 	 rows[index].descuento=(x);
					   			rows[index].descuento_adicional=(desc_suite);
							 }else{
							 	rows[index].descuento=(x);
							 }
							 

						}
						if(parseInt(rows[index].tipo_id)===2){
							 x=d_actualizacion;
							  y=m_actualizacion;
							  if(paquetes>1){
							 	 rows[index].descuento=(x);
					   			rows[index].descuento_adicional=(desc_suite);
							 }else{
							 	rows[index].descuento=(x);
							 }
						}
						if(parseInt(rows[index].tipo_id)===3){
							 x=d_cambio;
							 y=m_cambio;
							 rows[index].descuento=(x);
						}
						let uno =0;
						if(parseInt(ticket.tipo_precios)==0){
							// console.log("contado");
							uno = parseFloat(rows[index].producto.contado)/100;
						}else{
							// console.log("credito");
							uno = parseFloat(rows[index].producto.credito)/100;
						}

						let precio=uno*100;
						// console.log(precio);
						rows[index].precio=precio.toFixed(2);

						var PL=precio;
						////////console.log("PRECIO: "+PL);
						var DS=((PL/100)*desc_suite);
						// console.log("DESCUENTO SUITE: "+DS);
						var DD=0;						
						var DM=0;
						var iva_producto= parseFloat(rows[index].iva,10);										
					if(paquetes>1)
					{ 
						// console.log("mas de dos");
						////////console.log("PL - DS: "+(PL-DS));
						DD=(((PL-DS)/100)*x);
						// console.log("DESCUENTO DIST: "+DD);
						 DM=(((PL-DS)/100)*y);
						////////console.log("DESCUENTO MASTER: "+DM);


					   rows[index].costo=(PL-DS-DD-DM).toFixed(2);
					    var s=parseFloat(this.trunc((PL-DS-DD),3));
					    var i=s*(iva_producto/100);
				        var i2=parseFloat( this.trunc( i,2));
				        if(cantidad<1){
							i2=0;
						}
					    var t=(s+parseFloat(this.trunc( i,2) ) )*cantidad;							
					    rows[index].total=t.toFixed(2);	
					   //////// console.log(cantidad)
					   rows[index].descuento=(x);
					   rows[index].descuento_adicional=(desc_suite);
				    }
					else
					{   if(bandera){
						// console.log("unitario pero con descuento ");
						////////console.log("PL - DS: "+(PL-DS));
						DD=(((PL-DS)/100)*x);
						// console.log("DESCUENTO DIST: "+DD);
						 DM=(((PL-DS)/100)*y);
						////////console.log("DESCUENTO MASTER: "+DM);


					   rows[index].costo=(PL-DS-DD-DM).toFixed(2);
					
						var s=parseFloat(this.trunc((PL-DS-DD),3));
					    var i=s*(iva_producto/100);
				        var i2=parseFloat( this.trunc( i,2));
				        if(cantidad<1){
							i2=0;
						}
					    var t=(s+parseFloat(this.trunc( i,2) ) )*cantidad;							
					    rows[index].total=t.toFixed(2);	
					   //////console.log(cantidad)
					   rows[index].descuento=(x);
					   rows[index].descuento_adicional=(desc_suite);

						}else{
							// console.log("uno o menos")
						DD=(((PL)/100)*x);
                        // console.log("DESCUENTO DIST: "+DD);
						DM=(((PL)/100)*y);
						// console.log("DESCUENTO MASTER: "+DM);						
					    var s=parseFloat(this.trunc((PL-DD),3));
						// console.log("subtotal: "+s);
						var i=s*(iva_producto/100);; 
						// console.log("iva: "+this.trunc( i,2));
						var t=(s+parseFloat(this.trunc( i,2) ) )*cantidad;						
					    rows[index].total=t.toFixed(2);							
						rows[index].costo=(PL-DD-DM).toFixed(2);						
					//	// console.log((PL-DD))					
						// console.log((PL-DD))

						}
						
					}
			    

			}else
			{
				     if(parseInt( rows[index].producto.categoria_id)!==10){
				     	let uno =0;
	                 if(parseInt(ticket.tipo_precios)==0){
	                 	// console.log("contado");
	                 	 uno = parseFloat(rows[index].producto.contado)/100;
	                 	

	                 }else{
	                 	// console.log("credito");
	                 	 uno = parseFloat(rows[index].producto.credito)/100;
	                 	
	                 }
	                
	                 let precio=uno*100;
	                 // console.log(precio);
	                 rows[index].precio=precio.toFixed(2);

				var PL=precio;
				var incremento=parseFloat(rows[index].incremento,10);
				var descuento=parseFloat(rows[index].descuento,10);
				var inc=incremento;
				var desc=(PL/100)*descuento;
				var iva_producto= parseFloat(rows[index].iva,10);

				// console.log("descuento: "+desc);
				// console.log("incremento: "+incremento);
				var s=parseFloat(this.trunc((PL+inc-desc),3));
				// console.log("sub total: "+s.toFixed(2));

				var i=s*(iva_producto/100);
				var i2=parseFloat( this.trunc( i,2));
				// console.log("iva: "+i2)

				var t=(s+i2)*cantidad;
				// console.log("total: "+t)
				rows[index].total=t.toFixed(2);	
				// console.log((PL+inc-desc));
				if(cantidad<1){
					i2=0;
				}

				     }
				     

			}

            
	        // console.log('cantidad--->',cantidad);
	        // console.log('iva--->',i2*cantidad);
	        // console.log('subtotal--->',total-iva);
	        rows[index].combo=this.cambiar_precios_combo(rows[index].precio,rows[index].combo);
	        total=parseFloat(total)+ parseFloat(rows[index].total);
	        iva+= i2*cantidad;
		    subtotal+=total-iva;
	     					    
			}





        }//fin del if de conteo de row






        let sub=total-iva;
		ticket.iva=iva.toFixed(2);
		ticket.subtotal=sub.toFixed(2);
		ticket.total=total.toFixed(2);



		this.setState({
				ticket:ticket,
						rows:rows
				
					 });
	}

	cambiar_precios_combo(total,combo,bandera=true){
		total=parseFloat(total);
		// console.log('bandera combo--->',bandera)
		if(combo.length> 0&&bandera) 
        {
            for (var i = combo.length - 1; i >= 0; i--) 
            {       
                let porcentaje=parseFloat( combo[i].porcentaje);
                if(porcentaje>0){
                	let precio=0;
	                let total_producto=0;
	                let cantidad=parseFloat( combo[i].cantidad);
	                total_producto=(parseFloat(total)*porcentaje)/100;
	                precio=total_producto/cantidad;
	                combo[i].total=parseFloat( total_producto);
	                combo[i].precio=parseFloat( precio);
                }        
            }   
        }
		return combo;
	}
	

	sacar_total(tipo,lista,paq,bandera_combo=true) {
		var rows = lista;
		// // console.log(rows);
		let cliente=this.cliente;
		let paquetes=paq;
		let ticket=this.state.ticket;
		ticket.tipo_precios=parseInt(tipo);
		let total=0;
		let iva=0;
		let subtotal=0;		
		 	
    	if(rows.length> 0) 
		{
			
			for (var index = rows.length - 1; index >= 0; index--) 
			{		

			    var cantidad=parseInt(rows[index].cantidad,10);
			     if(isNaN(cantidad)){
				    	cantidad=0;
				    	rows[index].cantidad='';
			   		}

			if(parseInt( rows[index].producto.categoria_id)===8)
			{
				       
				        var d_paquete=parseFloat(cliente.tipo.dd_paquete,10);
						var d_actualizacion=parseFloat(cliente.tipo.dd_actualizacion,10);
						var d_cambio=parseFloat(cliente.tipo.dd_caracteristica,10);
						var m_paquete=parseFloat(cliente.tipo.dm_paquete,10);
						var m_actualizacion=parseFloat(cliente.tipo.dm_actualizacion,10);
						var m_cambio=parseFloat(cliente.tipo.dm_caracteristica,10);						
						var x=0;
						var y=0;
						var desc_suite=parseInt( rows[index].producto.descuento_suite,10);
						var bandera=true;
						// if((parseInt( rows[index].producto.descuento_suite,10)!==parseInt( rows[index].descuento_adicional)&&parseInt( rows[index].descuento_adicional)!==0)||parseInt( rows[index].descuento_adicional)!==0){
						// 	desc_suite=parseInt( rows[index].descuento_adicional);

						// 	bandera=true;
						// }
						if((parseInt( rows[index].producto.descuento_suite,10)!==parseInt( rows[index].descuento_adicional))){
							desc_suite=parseInt( rows[index].descuento_adicional);
							bandera=true;
						}
						//// console.log("bandera: "+bandera);
						//console.log(desc_suite);

						////////console.log(cliente.tipo)
						if(parseInt(rows[index].tipo_id)===1){
							 x=d_paquete;
							 y=m_paquete;
							 if(paquetes>1){
							 	 rows[index].descuento=(x);
					   			rows[index].descuento_adicional=(desc_suite);
							 }else{
							 	rows[index].descuento=(x);
							 }
							 

						}
						if(parseInt(rows[index].tipo_id)===2){
							 x=d_actualizacion;
							  y=m_actualizacion;
							  if(paquetes>1){
							 	 rows[index].descuento=(x);
					   			rows[index].descuento_adicional=(desc_suite);
							 }else{
							 	rows[index].descuento=(x);
							 }
						}
						if(parseInt(rows[index].tipo_id)===3){
							 x=d_cambio;
							 y=m_cambio;
							 rows[index].descuento=(x);
						}
						
						

						let precio=parseFloat(rows[index].precio);
						//console.log(precio);
						//rows[index].precio=precio.toFixed(2);

						var PL=precio;
						////////console.log("PRECIO: "+PL);
						var DS=((PL/100)*desc_suite);
					//	console.log("DESCUENTO SUITE: "+DS);
						var DD=0;						
						var DM=0;	
						var iva_producto= parseFloat(rows[index].iva,10);									
					if(paquetes>1)
					{ 
					//	console.log("mas de dos");
						////////console.log("PL - DS: "+(PL-DS));
						DD=(((PL-DS)/100)*x);
					//	console.log("DESCUENTO DIST: "+DD);
						 DM=(((PL-DS)/100)*y);
						////////console.log("DESCUENTO MASTER: "+DM);


					    var s=parseFloat(this.trunc((PL-DS-DD),3));
					    var i=s*(iva_producto/100);
				        var i2=parseFloat( this.trunc( i,2));
				        if(cantidad<1){
							i2=0;
						}
					    var t=(s+parseFloat(this.trunc( i,2) ) )*cantidad;							
					    rows[index].total=t.toFixed(2);		
					   rows[index].costo=(PL-DS-DD-DM).toFixed(2);
					   //////console.log(cantidad)
					   rows[index].descuento=(x);
					   rows[index].descuento_adicional=(desc_suite);
				    }
					else
					{   if(bandera){
						console.log("unitario pero con descuento ");
						////////console.log("PL - DS: "+(PL-DS));
						DD=(((PL-DS)/100)*x);
					//	console.log("DESCUENTO DIST: "+DD);
						 DM=(((PL-DS)/100)*y);
						////////console.log("DESCUENTO MASTER: "+DM);


					   rows[index].costo=(PL-DS-DD-DM).toFixed(2);
					//   console.log("subtotal:" +((PL-DS-DD)*cantidad));
					//   console.log("IVA:" +((PL-DS-DD)*cantidad)*0.16);
						
						
						

						var s=parseFloat(this.trunc((PL-DS-DD),3));
					    var i=s*(iva_producto/100);
				        var i2=parseFloat( this.trunc( i,2));
				        if(cantidad<1){
							i2=0;
						} 
					    var t=(s+parseFloat(this.trunc( i,2) ) )*cantidad;							
					    rows[index].total=t.toFixed(2);		
					   	
					   //////console.log(cantidad)
					   rows[index].descuento=(x);
					   rows[index].descuento_adicional=(desc_suite);

						}
						else{
					    // console.log("uno o menos")
						DD=(((PL)/100)*x);
                        // console.log("DESCUENTO DIST: "+DD);
						DM=(((PL)/100)*y);
						// console.log("DESCUENTO MASTER: "+DM);	
					
					var s=parseFloat(this.trunc((PL-DD),3));
					// console.log("subtotal: "+s);
					var i=s*(iva_producto/100);
			        var i2=parseFloat( this.trunc( i,2));
			        if(cantidad<1){
						i2=0;
					}  
					// console.log("iva: "+this.trunc( i,2));
					var t=(s+parseFloat(this.trunc( i,2) ) )*cantidad;						
					    rows[index].total=t.toFixed(2);							
						rows[index].costo=(PL-DD-DM).toFixed(2);						
					//	// console.log((PL-DD))

						}
						
					}
			    

			}else
			{
				     let precio=parseFloat(rows[index].precio);
						// console.log(precio);
						//rows[index].precio=precio.toFixed(2);

						var PL=precio;
				var incremento=parseFloat(rows[index].incremento,10);
				var descuento=parseFloat(rows[index].descuento,10);
				var inc=incremento;
				var desc=(PL/100)*descuento;
				var iva_producto= parseFloat(rows[index].iva,10);

				// console.log("descuento: "+desc);
				// console.log("incremento: "+incremento);
				var s=parseFloat(this.trunc((PL+inc-desc),3));
				// console.log("sub total: "+s.toFixed(2));

				var i=s*(iva_producto/100);
				var i2=parseFloat( this.trunc( i,2));
				// console.log("iva: "+i2)

				var t=(s+i2)*cantidad;
				// console.log("total: "+t)
				rows[index].total=t.toFixed(2);
		    	if(cantidad<1){
					i2=0;
				}

			}

            // console.log('cantidad--->',cantidad);
            rows[index].combo=this.cambiar_precios_combo(rows[index].precio,rows[index].combo,bandera_combo);
	        total=parseFloat(total)+ parseFloat(rows[index].total);
	        iva+= i2*cantidad;
		    subtotal+=total-iva;
	     //	console.log(total);					    
			}	
        }






      
          let sub=total-iva;
		ticket.iva=iva.toFixed(2);
		ticket.subtotal=sub.toFixed(2);
		ticket.total=total.toFixed(2);



		this.setState({
				ticket:ticket,
					rows:rows,
					paquetes:paquetes
				
					 });
	}
 trunc (sVal, nDec = 0) {
  // var s = x.toString()
  // var l = s.length
  // var decimalLength = s.indexOf('.') + 1
  // var numStr = s.substr(0, decimalLength + posiciones)
  // return Number(numStr)


    var n = parseFloat(sVal); 
    var s = "0.00"; 
    if (!isNaN(n)){ 
     n = Math.round(n * Math.pow(10, nDec)) / Math.pow(10, nDec); 
     s = String(n); 
     s += (s.indexOf(".") == -1? ".": "") + String(Math.pow(10, nDec)).substr(1); 
     s = s.substr(0, s.indexOf(".") + nDec + 1); 
    } 
    return s; 
}
	sacar_productos_suite(lista) {
		var rows = lista;
		//console.log(rows);	
		let total=0;
			
		let self = this;  	
    	if(rows.length> 0) 
		{
			//////console.log("entro");
			for (var i = rows.length - 1; i >= 0; i--) 
			{		
			if(parseInt( rows[i].producto.categoria_id)===8&&parseInt( rows[i].producto.descuento_suite,10)>0)
	        {
	        		 total++;
	        }		
	       
	        ////console.log("total renglon: "+rows[i].total);						    
			}	
        }
        	


		self.setState({
				paquetes: total				
					 });
	}


	getticket(data){

		let {ticket} = this.state;
	
		
		
		this.setState({
			ticket : data
		});
	}

	toggle(evt){

		let {ticket} = this.state;
		let action; 
		if(ticket.tipo_id === 4 && ticket.id === 0){
			action = 'save_ticket';
		}
		else
			action='pagar'

		this.setState({
			modal : !this.state.modal,
			action : action
		});
	}

	toggle_cliente(evt,cliente_id = null, title = "Agregar Cliente"){
		this.setState({
			modalCliente : !this.state.modalCliente,
			cliente_id : cliente_id,
            title       : title,
		})
	}
	get_cliente(cliente = null){
		
			this.cliente= cliente;
	
	}

	toggle_estado(evt,estado=1991){


		if(parseInt( estado)==1991)
		{
			this.setState({
			modalEstado : !this.state.modalEstado,
		})			
		}
		else
		{
			let {ticket} = this.state;	
			ticket["estado"]= estado;
			this.setState({
			modalEstado : !this.state.modalEstado,
			ticket:ticket			
		})
		}
		
		
	}

	toggle_dropdownOpen() {
		this.setState({ dropdownOpen: !this.state.dropdownOpen });
	}

	handleInputChange(event) {

		if(event === null) return;

		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;


		this.setState({
			ticket: {
				...this.state.ticket,
				[name]: value
			}
		});

	}

	// checkSign(type) {

	// 	//////console.log(type);

	// 	this.setState({ showSign: !this.state.showSign });


	// }

	handleSelectChange(select, name) {

		
		const value = select === null ? null : select.value;
		if(name==='proceso_id'&& parseInt(value)===4){ 
			swal("Oops..", "No puedes Cancelar Por aqui ");

		}else{

		this.setState({
			ticket: {
				...this.state.ticket,
				[name]: value
			}
		});
	    }
		let rows = this.state.rows;
		let paquetes=parseInt( this.state.paquetes);

		if (name==="tipo_precios"){
		this.cambiar_precios_total(parseInt(value),rows,paquetes);

		}

		if(name === "cliente_id") {

			this.cliente = select;
			// console.log(select)


		}

	}
	

	getClients(input, callback) {

		if(input != '') {

			api().get('/select/clientes', { params: {search: input} }).then(function(response) {

				callback(null, {
					options: response.data,
					complete: true
				});

			});

		}
		else {
			callback(null, {
				options: [],
				complete: true
			});
		}
	}
/*editor*/
	handleChangeEditor(editorState) {

		const content = convertToHTML(editorState.getCurrentContent());

		this.setState({
			ticket: { ...this.state.ticket, descripcion: content },
			editorState: editorState,
		});

	}


	submit() {
			let self = this;

		let {ticket,rows,compras} = this.state;

	
	if(this.props.ticket.saving){
		swal("Oops..", "Estamos en Proceso  ","warning");
		return false;
	}
	    // console.log('entro al submit')
		let save = true;
		let venta = true;
		let lista=true;  
		let vacio=true;


		var items 			= [];
		
		if(rows.length === 0) {
			if(ticket.tipo_id==4){
				lista = false;
			}else{
				if(ticket.proceso_id==3){
						lista = false;
					}
			}
			if(parseInt(ticket.estado)==3)
				lista = true; 
			
		}
		else if(rows.length > 0){
			// console.log('entreo a revisar los items');
			var producto="";
			var dato="";

			rows.some(function(obj) {
				
				var costo = parseFloat(obj.costo, 10);
				var precio = parseFloat(obj.precio, 10);
				var incremento = parseFloat(obj.incremento, 10);
				var descuento = obj.descuento;
				var descuento_adicional = obj.incremento;
				var cantidad = obj.cantidad;

				var categoria = parseInt(obj.producto.categoria_id, 10);
				var id = parseInt(obj.inventario_id, 10);
				var descripcion = obj.descripcion;
				// console.log("item: ",obj);

				if(id===0)
				{
					vacio = false;									
					return false;
				}
				if(descripcion==="" || descripcion==null)
				{
					lista = false;
					dato=" la Descripción";
					producto=obj.producto.nombre;
					return false;
				}
				if(cantidad==="" || cantidad==null)
				{
					lista = false;
					dato=" el Cantidad esta Vacio";
					producto=obj.producto.nombre;
					return false;
				}
				if(obj.incremento==="" || obj.incremento==null)
				{
					lista = false;
					dato=" el Incremento esta Vacio";
					producto=obj.producto.nombre;
					return false;
				}
				if(descuento==="" || descuento==null)
				{
					lista = false;
					dato=" el descuento esta Vacio";
					producto=obj.producto.nombre;
					return false;
				}
				if(descuento_adicional==="" || descuento_adicional==null)
				{
					lista = false;
					dato=" el Desc. suite esta Vacio";
					producto=obj.producto.nombre;
					return false;
				}
				if(categoria!==10){
					if( costo === 0 || isNaN(costo)) {
						
									lista = false;
									dato="el Costo";
									producto=obj.producto.nombre;
									return false;

								}
				}				
				if( precio === 0 || isNaN(precio)||precio<costo) {
					//////// console.log("precio error");
					lista = false;
					dato="el Precio";
					producto=obj.producto.nombre;
					return false;
				}

				if(categoria!==10&&categoria!==8)
				{
					if(precio>2000){
						if(self.validacion_incremento(precio,costo,incremento))
						{
							

						}else{
							// console.log("aqui con validacion falsa")
							dato="el Incremento";
							lista = false;		
							producto=obj.producto.nombre;					
							return false;
						}
					}else{
						if(incremento>0)
						{
							// console.log("incremento: "+incremento)
							// console.log("aqui sin validacion ")
							dato="el Incremento";
							lista = false;	
							producto=obj.producto.nombre;						
							return false;
						}
					}
					
			    }
			    let id_tabla=null;
			    if(parseInt(obj.value)>0)
			    	id_tabla=obj.value;

				items.push({
					id:id_tabla,
					inventario_id:obj.inventario_id,
					precio:obj.precio,
					costo:obj.costo,
					descuento:obj.descuento,
					descuento_adicional:obj.descuento_adicional,
					incremento:obj.incremento,	
					pago_comision:obj.pago_comision	,
					fecha_pago_comision:obj.fecha_pago_comision,		
					tipo_id:obj.tipo_id,
					iva:obj.iva,
					total:obj.total,
					descripcion:obj.descripcion,
					cantidad:obj.cantidad,
					combo_id:obj.combo_id,
					combo:obj.combo,								
				});

			});
		}

		ticket.items = items;
	    //console.log(ticket.items);
	    let b_compra=true;
        if( parseInt( ticket.proceso_id)==3)
	    compras.some(function(compra) {
	    	if(parseInt( compra.estado)<5){
	    		b_compra=false;
	    	}
	    });
	    if(!b_compra) {
			
				swal("Oops..", "Por favor Verificar las Compras Especiales Tienen que Estar en Maxicomm para Finalizar el Ticket ");
			
			
			return;
		}
		if(!vacio) {
			
				swal("Oops..", "Por favor Verificar los Productos se Encontraron datos incorrectos ");
			
			
			return;
		}
		if(!lista) {
			
				swal("Oops..", "Por favor Verificar los Productos se Encontraron datos incorrectos en "+ dato+"  en el producto "+producto, "error");
			
			
			return;
		}

		const {params} = this.props.match;

		let check = ['cliente_id', 'tipo_id'];



		if(parseInt( ticket['tipo_id'] )!== 4){
			// console.log("no es venta");

			if(parseInt(ticket['proceso_id']) !== 1){

				if(parseInt(ticket['tipo_id']) !== 1 ){
					// console.log("no es tienda");
					check = ['cliente_id', 'tipo_id','asistencia_id'];
				}else{
					// console.log(" es tienda");
					check = ['cliente_id', 'tipo_id','asistencia_id','descripcion_proceso','descripcion'];
				}
			}else{
				if(parseInt(ticket['tipo_id']) !== 1 ){
					// console.log("no es tienda");
					check = ['cliente_id', 'tipo_id','asistencia_id'];
				}else{
					// console.log(" es tienda");
					check = ['cliente_id', 'tipo_id','asistencia_id','descripcion'];
				}

			}		 
		}




		if(ticket['tipo_id'] === 4 && ticket['proceso_id'] !== 5)
			ticket['proceso_id'] = 3;

		

		
 // console.log('ticket submit---->',ticket);
		for(let i in check) {

			let key = check[i];

			let value = ticket[key];

			if(value == '' || value == null){
				save = false;
				// console.log('Campo--->',key);

			}

		}

		if(ticket.tipo_id == 2) {

			if(ticket.hora_cita == '' || ticket.fecha_cita == '')
				save = false;

		}

		if(!save) {
			swal("Oops..", "Por favor acompleta todos los campos", "error");
			return;
		}



		

		// update
		if(params.id) {

		if(ticket['proceso_id'] === 5){
			swal({
			title: 'Por favor escribe el motivo de la garantia',
			input: 'text',
			showCancelButton: true,
			confirmButtonText: 'Garantia',
			showLoaderOnConfirm: true,
			preConfirm: (no_factura) => {

				if(no_factura == "") {
					swal.showValidationError('Es requerio el motivo de la garantia');
				}
				else {
					ticket['motivo'] = no_factura;
					////////// console.log(ticket)
					return api().post('/ticketsv2/'+params.id, ticket )
					.then(response => response)
					.catch( error => {
						swal.showValidationError(`Request failed ${error}`);
					});
				}
			},
			allowOutsideClick: () => !swal.isLoading(),
		}).then((result) => {

			if (result.value) {
				if (result.value.status === 200) {
					swal("Bien hecho!", "El ticket se marco como garantia con éxito!", "success");
				}
			}
		});
		}
		else{
			//// console.log(ticket);

			this.props.update_ticket(ticket, (response) => {
				
				if(response.status){
				
					self.setState({ticket : response.ticket});


					swal("Bien hecho!", "El ticket fue editado con éxito!", "success");
				}else{
					swal("Error!", "El ticket Esta finalizado", "error");
				}

			});
		}
		}
		// create
		else {
			// if(parseInt( ticket['tipo_id']) !== 4&& parseInt( ticket['tipo_id']) !== 1){
			// 	var now = new Date(moment().format());
			// 	var myDate = new Date(ticket.fecha_cita+" "+ticket.hora_cita);		
			// 	if (now.getTime() > myDate.getTime()) {
			// 		save = false;
			// 	}
			// 	else {
			// 		// console.log("Es correcta");
			// 	}
			// }
			// if(!save) {
			// 	swal("Oops..", "Por favor de Verificar la Hora de la Cita", "error");
			// 	return;
			// }
			if(ticket.tipo_id !== 4){
				this.props.save_ticket(ticket, (data) => {
					swal("Bien hecho!", "El ticket fue creado con éxito!", "success");
				
					ticket.id = data.id;
					ticket.clave = data.clave;
					this.setState({ticket : ticket});
					this.props.history.push('/tickets/ver/'+data.id);
					this.props.get_llamadas(data.id);	
				});
				}
				else{
					this.toggle();
				}
			}
	}

	pay() {	
		if(parseFloat(this.state.ticket.total)>0){
			this.toggle();

		}else{
			swal("Error!", "El Ticket No puede ir Vacio", "error");
		}

		

		
	}
	pagar_credito() {	
		let {ticket} = this.state;
		let self =this;
              swal({
			  title: 'Estas seguro?',
			  text: "se pagara el ticket que esta marcado como credito",
			  type: 'warning',
			  showCancelButton: true,
			  confirmButtonColor: '#3085d6',
			  cancelButtonColor: '#d33',
			  confirmButtonText: 'Estoy Seguro!',
			   cancelButtonText: 'Cancelar!'
			}).then((result) => {
			  if (result.value) {
			  		
				

			  	let datos={
			  		id:ticket.id,
			  		fecha_credito_pagado:moment().format('Y-MM-DD'),
			  		
			  	};
			  	 this.props.pagar_credito(datos, (response) => {				
				if(response.status){				
					self.setState({ticket : response.ticket});
					swal("Bien hecho!", "El ticket fue editado con éxito!", "success");
				}

			});



		
			  }
			})
		

		
	}
	

	factura(){
		const {params} = this.props.match;

		let rol =parseInt(this.props.auth.user.rol);
		let departamento =parseInt( this.props.auth.user.departamento);

	
		if(departamento===17||(departamento===2&&rol>1)){
			swal({
				title: 'Por favor escribe el número de Factura o Remisión',
				input: 'select',
				inputOptions :
				{
					1 : 'Factura',
					2	: 'Remisión'
				},
				html : '<input id="swalInput2" class="swal2-input">',
				showCancelButton: true,
				confirmButtonText: 'Pagar',
				showLoaderOnConfirm: true,
				preConfirm: (no_factura,swalInput2) => {
					////////// console.log(no_factura)
					////////// console.log(document.getElementById('swalInput2').value)
					let numero = document.getElementById('swalInput2').value;
					if(no_factura == "") {
						swal.showValidationError('Es requerido un número de factura');
					}
					else {
						return api().post('/ticketsv2/pay/'+params.id, { tipo_numero : no_factura ,numero : numero ,departamento:departamento})
						.then(response => response)
						.catch( error => {
							swal.showValidationError(`Request failed ${error}`);
						});
					}
				},
				allowOutsideClick: () => !swal.isLoading(),
			}).then((result) => {

				
				
					if (result.value) {
						if(result.value.data.error){
					swal("Error!", "El ticket no esta Pagado", "error");

				}else{
					if (result.value.status === 200) {
						swal("Bien hecho!", "El ticket se marco como pagado validado con éxito!", "success");
					}
				}
				}


				

				

			});
		}else{
			swal("Error!", "No tienes Permiso de Agregar una factura", "error");
		}


	}

	cancel() {

		let rol =parseInt( this.props.auth.user.rol);
		// console.log('rol----->',rol);
		if(rol>1){
			const {params} = this.props.match;

		swal({
			title: 'Por favor Seleccione el motivo',
			input: 'select',
		inputOptions :
		{
			'La falla ya no se presento' : 'La falla ya no se presento',
			'Duplicidad de ticket'	: 'Duplicidad de ticket',
			'Cancelacion de Cita'	: 'Cancelacion de Cita',
			'Tiempo de Respuesta Tardia'	: 'Tiempo de Respuesta Tardia',
		},
			showCancelButton: true,
			confirmButtonText: 'Cancelar',
			 cancelButtonText: 'Atras',
			showLoaderOnConfirm: true,
			preConfirm: (motivo) => {

				if(motivo == '') {
					swal.showValidationError('Es requerido un motivo para cancelar el ticket');
				}
				else {
					return api().post('ticketsv2/cancel/'+params.id, { motivo: motivo })
					.then(response => response)
					.catch( error => { swal.showValidationError(`Request failed ${error}`); });
				}
			},
			allowOutsideClick: () => !swal.isLoading(),
		}).then((result) => {

			if (result.value) {
				if (result.value.status === 200) {
					swal("Bien hecho!", "El ticket se marco como cancelado con éxito!", "success");
				}
			}

		});

		}else{
			swal("Error!", "No tienes Permiso para Cancelar el Ticket ponte en Contacto con el Supervisor", "error");
		}
		
	}

	no_aprobado() {
			const {params} = this.props.match;
			let self = this;
     swal({
			title: 'Por favor Seleccione el motivo de no aprobado',
			input: 'select',
		inputOptions :
		{
			'La falla ya no se presento' : 'La falla ya no se presento',
			'Duplicidad de ticket'	: 'Duplicidad de ticket',
			'Cancelacion de Cita'	: 'Cancelacion de Cita',
			'Tiempo de Respuesta Tardia'	: 'Tiempo de Respuesta Tardia',
		},
			showCancelButton: true,
			confirmButtonText: 'Cancelar',
			 cancelButtonText: 'Atras',
			showLoaderOnConfirm: true,
			preConfirm: (motivo) => {

				if(motivo == '') {
					swal.showValidationError('Es requerido un motivo para Marcar  el ticket como no aprobado');
				}
				else {
					return api().post('/ticketsv2/noaprobado/'+params.id, { motivo: motivo })
		            .then(function(response)
		            {    
		                console.log('response-->',response)    
		                if(response.status === 200)
		                {
		              
		                     self.setState({ticket : response.data.ticket});  
		                 
		                }
		            })
		            .catch(() => {
		              swal.insertQueueStep({
		                type: 'error',
		                title: 'Solicitar ayuda a un Administrador',
		              })
		            })
				}
			},
			allowOutsideClick: () => !swal.isLoading(),
		}).then((result) => {

			if (result.value) {
				if (result.value.status === 200) {
					swal("Bien hecho!", "El ticket se marco como no aprobado con éxito!", "success");
				}
			}

		});
	}
	formateo(value) {
     var decimals =  2;
   var  separators =[',', ",", '.'];
    var number = (parseFloat(value) || 0).toFixed(decimals);
    if (number.length <= (4 + decimals))
        return '$' +number.replace('.', separators[separators.length - 1]);
    var parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];
    var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
    var start = value.length - 6;
    var idx = 0;
    while (start > -3) {
        result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
        idx = (++idx) % 2;
        start -= 3;
    }
    return '$' + result;
}

restauracion() {
 let self =this;
		let pv =parseInt( this.state.ticket.pv);
		// console.log('pv----->',pv);
		if(pv===0){
			  swal({
			  title: 'Estas seguro?',
			  text: "El ticket se regresara al estado de proceso y se quitara el pago",
			  type: 'warning',
			  showCancelButton: true,
			  confirmButtonColor: '#3085d6',
			  cancelButtonColor: '#d33',
			  confirmButtonText: 'Estoy Seguro!',
			   cancelButtonText: 'Cancelar!'
			}).then((result) => {
			  if (result.value) {			
              const {params} = this.props.match;
			  	

			  		
		swal({
			title: 'Por favor escribe el motivo de restauracion de ticket',
			input: 'text',
			text: ' (el ticket se pondra en proceso  y se quitara el pago)',
			showCancelButton: true,
			confirmButtonText: 'Aceptar',
			cancelButtonText: 'Atras',
			showLoaderOnConfirm: true,
			preConfirm: (motivo) => {

				if(motivo == '') {
					swal.showValidationError('Es requerido un motivo para restaurar el ticket');
				}
				else {
					let datos={
			  		id:params.id,
			  		insidencia:1,
			  		proceso_id:2,
			  		pagado:0,
			  		fecha_pago:null,
			  		fecha_finalizado:null,
			  		tipo_pago:1,
			  		anexo_tipo_pago:null,
			  		cobro_id:0,
			  		motivo_tecnico:motivo.toUpperCase(),
			  	    };
					 return api().post('ticketsv2/full_update/'+params.id, datos)
					 .then(response => response)
					 .catch( error => { swal.showValidationError(`Request failed ${error}`); });
					
				}
			},
			allowOutsideClick: () => !swal.isLoading(),
		}).then((result) => {

			if (result.value) {
				if (result.value.status === 200) {
					//// console.log("result--->",result.value.data)
					self.setState({ticket : result.value.data});
							swal("Bien hecho!", "El ticket fue editado con éxito!", "success");
				}
			}

		});
			



		
			  }
			})

		

		}else{
			swal("Error!", "No tienes Permiso para Modificar el Ticket ponte en Contacto Con el Departamento Sistemas", "error");
		}
		
	}


	render() {

		let {ticket, editorState,departamentos,paquetes,usuarios,reset,rows,index} = this.state;

		const {params} = this.props.match;

		let {edit} = this.state;

		let show = false;
		// // console.log("Cliente-->",this.cliente);
		// if (this.state.rows.length>0&&parseInt(this.state.index)>=0) 
		// {
		// 	if(parseInt(this.state.rows[parseInt( this.state.index)].producto.categoria_id)===10)
		// 	{
        //             // console.log("Servicio");
		// 	}else{
		// 		// console.log("otro");

		// 	}
		// 	// console.log(parseInt(this.state.rows[parseInt( this.state.index)].producto.categoria_id));
			
		// }else
		// {
		// 	// console.log("index:"+this.state.index);
		// }

		let rol =parseInt( this.props.auth.user.rol);
		let departamento =parseInt( this.props.auth.user.departamento);
		// console.log('form productos---->',rows);
		// console.log('index----->',index);
		if (rows.length>0&&parseInt(this.state.index)>=0&&this.state.modal_descripcion ) {
	    // console.log('producto seleccionado----->',rows[index]);
		// // // // // // // // // console.log('combo seleccionado----->',rows[index].combo);
}
		
		

		let opciones, etiqueta;
		
		if(departamento===2)
		{
			opciones = servicios_contpaq;
			etiqueta = 'Tipo de apoyo';
		}else
		{
			switch(parseInt(ticket.tipo_id,10)){
			case 1:
				opciones = asistencias;
				etiqueta = 'Recepción:';
				break;
			case 2:
				opciones = asistencias;
				etiqueta = 'Tipo de equipo';
				break;
			case 3: 
				opciones = asistencias;
				etiqueta = 'Tipo de apoyo';
				break;
			case 4: 
				opciones = ventas;
				etiqueta = 'Linea:';
				break;
			case 5: 
				show = true;
				break;
		}

		}
		
		return(
			<div className="view">

				<div className="view-header">
					<header className="title text-white">
						<h1 className="h4 text-uppercase">Ticket : {ticket.clave}</h1>
					</header>
				</div>

				<div className="view-content view-components">
					<Card className="mb-4">
						<CardBlock>

							<div className="row mb-4">
								<div className="text-left col-sm-2">
									<ButtonGroup>
										<Link to="/tickets">
											<Button color="secondary">
												<FAchevronleft />
											</Button>
										</Link>
										<Button color="secondary" onClick={this.submit} >
											<FAfloppyO />
										</Button>
									</ButtonGroup>
								</div>
								{
									params.id &&
									<div className="text-right col-sm-10">
										<ButtonGroup>
											{(parseInt(ticket.proceso_id)===4)&&
												<Button color="warning" onClick={(click) => { this.firma(3) }}  title="Firma de Recepcion">
													Firma No Aprobado
											    </Button>
											}
											{(parseInt(ticket.proceso_id)<=2)&&
												<Button color="info" onClick={(click) => { this.firma(1) }}  title="Firma de Recepcion">
													Firma Recepcion
											    </Button>
											}
											{(parseInt(ticket.proceso_id)===3)&&
											    <Button color="warning" onClick={(click) => { this.firma(2) }}  title="Firma de Finalizado">
													Firma Finalizado
											    </Button>
											}
											{(parseInt(ticket.pv)===0&&parseInt(ticket.proceso_id)===3&&parseInt(ticket.pagado)>0&&parseInt(ticket.factura_id)>0)&&
												<Link to={"/invoiceModule/edit/"+ticket.factura_id}>
													<Button color="secondary" title='Factura/Remision'>
														<IconFacturaRemision />
													</Button>
												</Link>		
											}				

										    {(parseInt(ticket.pv)===0&&parseInt(ticket.proceso_id)===3&&parseInt(ticket.pagado)>0&&parseInt(ticket.factura_id)===0)&&
												<Button color="primary" onClick={this.toggle_factura}  title="Facturar Ticket">
												Facturar
											    </Button> 										

										    }
										    {(parseInt(ticket.pv)===0&&parseInt(ticket.proceso_id)===3&&parseInt(ticket.pagado)>0&&parseInt(ticket.factura_id)===0)&&
												<Button color="success" onClick={this.remisionar}  title="Remisionar Ticket">
												Remisionar
											    </Button> 										

										    }

										    {(parseInt(ticket.pv)===0&&parseInt(ticket.proceso_id)!=4)&&
												<Button color="secondary" onClick={this.restauracion}  title="Restauracion del Ticket">
												<IconRetorno color="green" />
											    </Button> 										

										    }

										    {(parseInt(ticket.pagado)===2&&ticket.fecha_credito_pagado==null)&&
												<Button color="secondary" onClick={this.pagar_credito}  title="Pagar Credito">
												<IconNote color="green" />
											</Button> 										

										    }
											<Button color={estadoCliente[parseInt(ticket.estado)-1]} onClick={this.toggle_estado} title="Registrar llamada">
												<FaCel />
											</Button>
										
											<a href={API_URL+"/ticketsv2/printRecepcion/"+params.id} target="_blank">
												<Button color="secondary" title="Ticket Recepción">
													<FAprint />
												</Button>
											</a>
										
											{(parseInt(ticket.proceso_id)===3||(departamento===2&&rol>1))&&
												<Button color="secondary" onClick={this.pay}  title="Pagar Ticket">
												<FAdollar color="green" />
											    </Button> 										

										    }										    
										 	{(parseInt(ticket.proceso_id)===3||(departamento===2&&rol>1))&&
												<Button color="secondary" onClick={this.imprimir_pago} title="Ticket Cobro">
													<FAprint color="green" />
												</Button>
											}
											{/*(parseInt(ticket.proceso_id)===3||(departamento===2&&rol>1))&&
												<Button color='secondary' onClick={this.factura} title="Factura"  title="Registrar Factura/Remisión">
												<FaFac color="blue"/>
											    </Button>*/
											}
											
											{(parseInt(rol)==4)&&
											<Button color="secondary" onClick={this.cancel}  title="Cancelar Ticket">
												<FAban color="red" />
											</Button>
											}
											{(parseInt(ticket.proceso_id)<=2)&&
											<Button color="secondary" onClick={this.no_aprobado}  title="Ticket No Aprobado">
												<IconNoAprobado color="red" />
											</Button>
											}
										</ButtonGroup>
									</div>
								}
							</div>

							<div className="row">


								<div className="col-md-6">

									<div className="row">
										<div className="col-md-12">
											<h6 className="mb-4 text-uppercase">Información</h6>
											
										</div>

										 <div className="col-md-12">
											<div className="row">
												{params.id && <div className="col-md-6">
													<div className="form-group">
														<label className>Proceso:</label>
														<Select
															placeholder=""
															type="text"
															name="proceso_id"
															options={procesos}
															value={parseInt(ticket.proceso_id) || 0}
															onChange={ (select) => { this.handleSelectChange(select, 'proceso_id') } }
															clearable={false}
														/>
													</div>
												</div>}											
											</div>
										</div>

									
									</div>

									<div className="row">
										<div className="col-md-12">
											<div className="row">
												<div className="col-md-6">
													<div className="form-group">
														<label className>Tipo de Ticket:</label>
														<Select
															placeholder=""
															type="text"
															name="tipo_id"
															options={tipos}
															value={parseInt(ticket.tipo_id) || ""}
															onChange={ (select) => { this.handleSelectChange(select, 'tipo_id') } }
															disabled={edit}
															clearable={false}
														/>
													</div>
												</div>
												{
													parseInt(ticket.tipo_id)!==4&&
													<div className="col-md-6">
													<div className="form-group">
														<label className>{etiqueta}</label>
														<Select
															placeholder=""
															type="text"
															name="asistencia_id"
															options={opciones}
															value={parseInt(ticket.asistencia_id)}
															onChange={ (select) => { this.handleSelectChange(select, 'asistencia_id') } }
															disabled={edit}

														/>
													</div>
												</div>
												}
												
											</div>
										</div>
									</div>

									
										<div className="row">
										<div className="col-md-12">
											<div className="row">
											{ ticket.tipo_id == 2 && 
												<div className="col-md-6">
													<div className="form-group">
														<label className>Fecha de Cita:</label>
														<input
															type="date" 
															className="form-control"
															name="fecha_cita"
															value={ticket.fecha_cita || ''}
															onChange={this.handleInputChange}
															readOnly={edit}
														/>
													</div>
												</div>
											}{ ticket.tipo_id == 2 && 
												<div className="col-md-6">
													<div className="form-group">
														<label className>Hora de Cita:</label>
														<input
															type="time"
															className="form-control"
															name="hora_cita"
															value={ticket.hora_cita || ''}
															onChange={this.handleInputChange}
															readOnly={edit}
														/>
													</div>
												</div>
											}
												<div className="col-md-6">
													<div className="form-group">
														<label className>Asignado a :</label>
														<Select
															placeholder=""
															type="text"
															name="usuario_id"
															options={usuarios}
															value={parseInt(ticket.usuario_id)}
															onChange={ (select) => { this.handleSelectChange(select, 'usuario_id') } }
															disabled={edit}
															clearable={false}
														/>
													</div>
												</div>

											</div>
										</div>
									</div> 
								

									

									<div className="row">
										<div className="col-md-12">
											<div className="row">
												<div className="col-md-9">
													<div className="form-group">
														<label className>Cliente:</label>
														<Async 
															placeholder=""
															name="cliente_id"
															loadOptions={ _.debounce(this.getClients, 300) } 
															value={parseInt(ticket.cliente_id)}
															onChange={ (select) => { this.handleSelectChange(select, 'cliente_id') } }
															disabled={(edit)}
														/>
													</div>
												</div>
												{ 
													!edit &&
												<div className="col-md-3">
													<label><br/></label><br/>
													<Button onClick={this.toggle_cliente}>+</Button>{' '}
													{ 
													this.cliente &&
													 <Button
	                                                 color="success"                                                
	                                                 onClick={(evt)=>this.toggle_cliente(evt,this.cliente.value, 'Editar Cliente')}>
                                                     <IconEdit />
                                                     </Button>
                                                     }

												</div>
												}
											</div>
											{ this.cliente != null ? <div className="row">
												<div className="col-md-12">
													{this.cliente.contacto || '-' }
													<br/><Badge color="default" pill>CONTACTO</Badge>
												</div>
												<div className="col-md-12">
													{this.cliente.correo || '-' }
													<br/><Badge color="default" pill>CORREO</Badge>
												</div>
												<div className="col-md-4">
													{this.cliente.telefono || '-' }
													<br/><Badge color="default" pill>TELEFONO</Badge>
												</div>
												<div className="col-md-6">
													{this.cliente.rfc || '-' }
													<br/><Badge color="default" pill>RFC</Badge>
												</div>
												<div className="col-md-12">
													{this.cliente.rSocial || '-' }
													<br/><Badge color="default" pill>RAZÓN SOCIAL</Badge>
												</div>
												<div className="col-md-12">
													{this.cliente.domicilio || '-' }
													<br/><Badge color="default" pill>DOMICILIO</Badge>
												</div>
												<div className="col-md-6">
													{this.cliente.ciudad || '-' }
													<br/><Badge color="default" pill>CIUDAD</Badge>
												</div> 
											</div>
											: <div><br/><br/><br/><br/><br/><br/><br/><br/><br/></div>
											 }
										</div>
									</div>


								</div>

								<div className="col-md-6">

									 <div className="row">
										<div className="row">
										<div className="col-md-12">
											<div className="row">
												<div className="col-md-12">
													<div className="form-group">
														<label className>Descripción Recepción</label>
														<Input
														rows={3}														
							                			  type="textarea"
							                			  name="descripcion"
							                			  value={ticket.descripcion} 
							                			 className="form-control texto_normal"
							                			  onChange={ (e) => this.handleSelectChange(e.target,e.target.name) }
							                			  />
														
													</div>
												</div>												
													<div className="col-md-12">
													<div className="form-group">
														<label className>Descripción Proceso / Diagnostico</label>
														<Input
														rows={3}														
							                			  type="textarea"
							                			  name="descripcion_proceso"
							                			  value={ticket.descripcion_proceso} 
							                			 className="form-control texto_normal"
							                			  onChange={ (e) => this.handleSelectChange(e.target,e.target.name) }
							                			  />
													</div>
												</div>
												
												
												
											</div>
										</div>
									</div>
									</div>
							{
							params.id &&		
							<div className="row">
								<div className="col-md-12">
				                    <Card>
				                        <CardBlock>
					                        <Nav tabs>
						                      <NavItem>
						                        <NavLink
						                          className={classnames({ active: this.state.activeTab === '1' })}
						                          onClick={() => { this.toggle_tab('1'); }}
						                        >
						                          Compras Especiales
						                        </NavLink>
						                      </NavItem>
						                      <NavItem>
						                        <NavLink
						                          className={classnames({ active: this.state.activeTab === '2' })}
						                          onClick={() => { this.toggle_tab('2'); }}
						                        >
						                         Llamadas
						                        </NavLink>
						                      </NavItem>
						                    </Nav>
						                     <TabContent activeTab={this.state.activeTab}>
						                     <TabPane tabId="1">
						                     <Row>
						                      <Col className={'mt-2 mb-4'} sm="12">

						                      <Row>
						                      {
						                        	ticket.fecha_anticipo==null&&
						                      	<div className="col-md-12">
						                            <FormGroup>
						                                <Label>Descripcion</Label>
						                                    <Input
						                                    placeholder=""
						                                    type="text"
						                                    name="descripcion_compra"
						                                    value={this.state.descripcion_compra}
						                                    onChange={ this.handleInputChangeState}
						                                    />
						                            </FormGroup>
						                        </div>}
						                        {
						                        	ticket.fecha_anticipo==null&&
						                        <div className="col-md-4">
						                            <FormGroup>
						                                <Label>Precio</Label>
						                                    <Input
						                                    placeholder=""
						                                    type="number"
						                                    name="precio_compra"
						                                    value={this.state.precio_compra}
						                                    onChange={ this.handleInputChangeState}
						                                    />
						                            </FormGroup>
						                        </div>
						                    }
						                        <div className="col-md-4 pt-4">
						                        {
						                        	ticket.fecha_anticipo==null&&
						                        	<Button
	                                                 color="success" 
	                                                 className="btn-sm mt-3" 
	                                                 onClick={this.agregar_compras}>
	                                                    Agregar <FaPlus />
	                                                </Button>
						                        }
							                        {' '}
							                        {
						                        	ticket.fecha_anticipo==null&&
	                                                <Button
	                                                 color="primary" 
	                                                 className="btn-sm mt-3" 
	                                                 onClick={this.recargar_compras}>
	                                                    Recargar 
	                                                </Button>}{' '}
	                                               
	                                                
						                        </div>
						                      </Row>
						                      <Row>					
						                      <Col className={'mt-2 mb-4'} sm="8">
						                      		<FormGroup>
						                                <Label>Anticipo   Min:{this.formateo(ticket.anticipo_min||0.00)}</Label>
						                                    <Input
						                                    placeholder=""
						                                    type="number"
						                                    name="anticipo"
						                                    value={ticket.anticipo}
						                                    onChange={this.handleInputChange}
						                                    readOnly={ticket.fecha_anticipo==null?false:true}
						                                    />
						                            </FormGroup>
						                            </Col>	
						                       <Col className={'mt-3 mb-4'} sm="4">					                      
						                      	<Button
	                                                 color="primary" 
	                                                 className=" ml-4 mt-4 btn-sm" 
	                                                 onClick={this.imprimir_anticipo}>
	                                                    Imprimir Anticipo 
	                                                </Button>						                      
						                      </Col>
						                     </Row>
						                      

						                      
						                     </Col>
						                     </Row>
						                     <Row>
						                      <Col sm="12">
						                      <ReactTable
					                              data      = {this.state.compras}
					                              className = "-striped -highlight"
					                              columns   = {[				                               
					                                                             
					                                {Header: 'Descripción', accessor: 'descripcion'},
					                                {
					                                    Header: 'Controles',
					                                    filterable: false,
					                                    sortable: false,
					                                    maxWidth:150,
					                                    Cell: (row) =>
					                                    {
					                                        return(
					                                            <div className="text-right">
					                                            { parseInt( row.original.estado)==0&&

					                                                <Button
					                                                 color="warning" 
					                                                 className="btn-sm" 
					                                                 onClick={(evt)=>this.cancelar_compra( row.original)}>
					                                                    <FAban />
					                                                </Button>
					                                            }{' '}
					                                                 
					                                            </div>
					                                        )
					                                    }
					                                },
					                              
					                              ]}                             
					                             
					                              filterable 
					                              defaultPageSize={5} 
					                              defaultFilterMethod={filterCaseInsensitive}

					                             SubComponent={ row => {
					                                return(
					                                    <Card>
					                                        <CardBlock>
					                                            <CardTitle className="h6 text-uppercase mb-4">Datos: </CardTitle>
					                                            <hr/>
					                                                <p>Estado: {estados_compra[parseInt( row.original.estado)].label}</p>
					                                                <p>Fecha compra: {row.original.fecha_compra}</p>
					                                                <p>Precio: {row.original.precio_formato}</p>
					                                                <p>Fecha Actualizacion: {row.original.actualizacion}</p>
					                                                <p>Fecha Arribo: {row.original.fecha_arribo}</p>
					                                                <p>Nota: {row.original.nota}</p>
					                                             <hr/>
					                                        </CardBlock>
					                                    </Card>
					                                )
					                              }}
	                            				/>
						                     </Col>
						                     </Row>
						                     </TabPane>
						                      <TabPane tabId="2">
						                       <ReactTable
					                              data      = {this.props.ticket.llamadas}
					                              className = "-striped -highlight"
					                              columns   = {[
					                               
					                                {Header: 'Fecha', accessor: 'fecha'},
					                                {Header: 'Usuario', accessor: 'usuario'},                              
					                                {Header: 'Estado', accessor: 'estado'},
					                              
					                              ]}                             
					                             
					                              filterable 
					                              defaultPageSize={5} 
					                              defaultFilterMethod={filterCaseInsensitive}

					                             SubComponent={ row => {
					                                return(
					                                    <Card>
					                                        <CardBlock>
					                                            <CardTitle className="h6 text-uppercase mb-4">Nota: </CardTitle>
					                                            <hr/>
					                                                <p>{row.original.nota}</p>
					                                             <hr/>
					                                        </CardBlock>
					                                    </Card>
					                                )
					                              }}
	                            				/>
						                     </TabPane>


						                     </TabContent>



					                           
                        				</CardBlock>
                    				</Card>
                				</div> 
                			</div> 
                		}
				    </div>
				</div>
				 <div className="my-4 separador"/>
				 	<div className="row">
												
												<div className="col-md-3">
													<div className="form-group">
														<label className>Tipo de Precios:</label>
														<Select
															placeholder=""
															type="text"
															name="tipo_precios"
															options={tipos_precios}
															value={parseInt(ticket.tipo_precios) || 0}
															onChange={ (select) => { this.handleSelectChange(select, 'tipo_precios') } }
															 disabled= {(parseInt(ticket.pagado)===0)? false : true}
															 clearable={false}
														/>
													</div>
												</div>
											</div>
				 <Badge color="default" pill>Productos para suite:{paquetes}</Badge>
				<div className="row mb-4">
						<div className="col-12 col-md-12">							
							<table className="table tabla_items">
						        <thead>
						            <tr>
						                <th>Catalogo</th>
						                <th>tipo</th>

						                <th>Ult. precio</th>
						                <th>precio lista</th>
						                <th>Costo</th>
						                <th>Cantidad</th>
						                <th>Incremento</th>
						                <th>Descuento</th>
						                <th>Desc.Suite</th>
						                <th>IVA % </th>
						                <th>Total</th>
						                <th>{
					                			((parseInt(ticket.pagado)===0&&parseInt(ticket.pv)===0)&& typeof this.cliente !== 'undefined')&&<Button color="primary" outline onClick={ (button) => { this.toggle_modal(26,"Productos","inventario_id") } }>Add</Button>
					            }</th>
						            </tr>
						        </thead>
						        <tbody className="">
						            {this.state.rows.map((item, i) => 
					            		<tr key={i}>
					                		<td width="15%">
					                			<Select
					                			  options={this.state.items} 
					                			  value={parseInt(item.inventario_id)}
					                			  disabled ={parseInt(item.inventario_id)===0? false : true}
					                			   onChange={ (e) => this.updatecampos(e.value, i,"inventario_id") }
					                			   name="inventario_id"
					                			    clearable={false}
					                			  />
					                		</td>
					                		<td width="9%">
					                			<Select
					                			  options={(parseInt(item.producto.categoria_id)===8)? tipos_contpaq : tipos_productos} 
					                			  value={parseInt( item.tipo_id)}
					                			  name="tipo_id"
					                			   clearable={false}
					                			   onChange={ (e) => this.updatecampos(e.value, i,"tipo_id") }
					                			  disabled= {(parseInt(item.producto.categoria_id)===8&&(parseInt(ticket.pagado)===0&&parseInt(ticket.pv)===0)&&parseInt(item.tipo_id)===0)? false : true}
					                			  />
					                		</td>
					                		<td width="10%">
					                			<Input
					                			  type="text"
					                			  name="precio"
					                			  value={item.ultimo_precio} 
					                			  disabled 
					                			  
					                			  />
					                		</td>
					                		<td width="10%">
					                			<Input
					                			  type="number"
					                			  name="precio"
					                			  value={item.precio} 
					                			  disabled ={(parseInt(ticket.pagado)===0&&parseInt(ticket.pv)===0)? false : true}
					                			  onChange={ (e) => _.debounce(this.updatecampos(e.target.value, i,e.target.name),1500 )}
					                			
					                			  />
					                			  
					                		</td>
					                		<td width="10%">
					                			<Input
					                			  type="number"
					                			  name="costo"
					                			  value={item.costo} 
					                			  readOnly ={ item.combo.length>0?true:false }
					                			   disabled ={(parseInt(ticket.pagado)===0&&parseInt(ticket.pv)===0)? false : true}
					                			   onChange={ (e) => this.updatecampos(e.target.value, i,e.target.name) }
					                			   />
					                		</td>
					                		<td width="5%">
					                			<Input
					                			  type="number"
					                			  name="cantidad"
					                			  value={item.cantidad} 
					                			   onChange={ (e) => this.updatecampos(e.target.value, i,e.target.name) }
					                			   disabled ={(parseInt(ticket.pagado)===0&&parseInt(ticket.pv)===0)? false : true}
					                			   />
					                		</td>
					                		<td width="5%">
					                			<Input
					                			  type="number"
					                			  name="incremento"
					                			  value={item.incremento} 
					                			   onChange={ (e) => this.updatecampos(e.target.value, i,e.target.name) }
					                			  disabled ={( (parseInt(item.producto.categoria_id)>=3&&parseInt(item.producto.categoria_id)<=6) && (parseInt(ticket.pagado)===0&&parseInt(ticket.pv)===0))? false : true}
					                			   />
					                		</td>
					                		
					                		<td width="5%">

					                		{
					                		parseInt(item.producto.categoria_id)===10?
					                			<Select
				                                    placeholder=""
				                                    type="text"
				                                    name="descuento"
				                                    options={descuentos}
				                                    value={parseInt(item.descuento)}
				                                     onChange={ (e) => this.updatecampos(e.value, i,"descuento") }
					                			    disabled ={(parseInt(item.producto.categoria_id)===10&&(parseInt(ticket.pagado)===0&&parseInt(ticket.pv)===0))? false : true}
				                                    clearable={false}
				                                    />:<Input
					                			  type="number"
					                			  name="descuento"
					                			  value={item.descuento} 
					                			   onChange={ (e) => this.updatecampos(e.target.value, i,e.target.name) }
					                			  disabled ={(parseInt(item.producto.categoria_id)===10&&(parseInt(ticket.pagado)===0&&parseInt(ticket.pv)===0))? false : true}
					                			  />
					                		}
					                			
					                		
					                		</td>
					                		<td width="5%">
					                			<Input
					                			  type="number"
					                			  name="descuento_adicional"
					                			  value={item.descuento_adicional} 
					                			   onChange={ (e) => this.updatecampos(e.target.value, i,e.target.name) }
					                			  disabled ={(parseInt(item.producto.categoria_id)===8&&(parseInt(ticket.pagado)===0&&parseInt(ticket.pv)===0))? false : true}
					                			   />
					                		</td>
					                		<td width="8%">
					                			{item.iva+' %'}
					                		</td>
					                		<td width="10%">
					                			<Input
					                			  type="number"
					                			  name="total"
					                			  value={item.total} 
					                			   onChange={ (e) => _.debounce(this.updatecampos(e.target.value, i,e.target.name), 1000) }
					                			  disabled ={(parseInt(item.producto.categoria_id)!==8&&(parseInt(ticket.pagado)===0&&parseInt(ticket.pv)===0))? false : true}
					                			  />
					                		</td>
					                		
					                		<td width="10%">
					                			<ButtonGroup>
					                		{
					                			(parseInt(ticket.pagado)===0&&parseInt(ticket.pv)===0)&&

					                			<Button
					                			  color="danger"
					                			  
					                			 onClick={this.deleteRow.bind(this, i)}>
					                			  	X
					                			</Button>
					                			}
					                			&nbsp;
					                			{
					                			(parseInt(ticket.pagado)===0&&parseInt(ticket.pv)===0)&&

					                			<Button
					                			  color="primary"	
					                			 onClick={this.modal_descripcion.bind(this, i)}>
					                			  	<IconEdit/>
					                			</Button>
					                			}
					                				</ButtonGroup>
					                		</td>
					                		
					                		
					            		</tr>
						            )}
						        </tbody>
						    </table>
						    <hr/>
						    	<div className="row ">
						    		<div className="col-md-8 float-right">
						    		</div>
						    		<div className="col-md-4 float-right">
								    	<table className="table">{/*sumatoria de productos */}
								    		<thead>
								    			<tr>
								                	<th>sub-total:</th>
								                	<td>
								    					<Input
								    						type="text"
								    						name="sub-total"
								    						value={this.formateo(this.state.ticket.subtotal)}
								    					/>
								    				</td>
								    			</tr>
								    			<tr>
								                	<th>iva:</th>
								                	<td>
								    					<Input
								    						type="text"
								    						name="sub-total"
								    						value={this.formateo(this.state.ticket.iva)}
								    					/>
								    				</td>
								                </tr>
								                <tr>
								                	<th>Total:</th>
								                	<td>
								    					<Input
								    						type="text"
								    						name="sub-total"
								    						value={this.formateo(this.state.ticket.total)}
								    					/>
								    				</td>
								                </tr>
								    		</thead>
								    	</table>
								    </div>
								   
						    	</div>

						    	
						    	<div className="float-right">
						    		<Button onClick={this.submit}> Guardar</Button> {/*reemplaza el boton de arriba */}
						    	</div>
						    </div>


						    <div className="my-4 separador"/>
						    <div className="my-4 separador"/>
					</div>

				<VentaModal
					open={this.state.modal}
					toggle={this.toggle}
					ticketVenta={this.state.ticket}
					history={this.props.history}
					action={this.state.action}
					getticket={this.getticket}
				/>
                {this.state.modalCliente&& 
				<ClienteModal
					open={this.state.modalCliente}
					toggle={this.toggle_cliente}
					title={this.state.title} 
                    prospectoid={this.state.cliente_id}
                    get_cliente={this.get_cliente}
				/>
			    }
			     { this.state.modal_articulo&&
                <ModalTablas
                    open={this.state.modal_articulo}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                    no_agregar={false}
                />
            }

            { this.state.modal_factura&&
                <ModalFactura
                    open={this.state.modal_factura}
                    toggle={this.toggle_factura}  
                    correo={this.toggle_correo}
                    tic={ticket}                
                />
            }
            { this.state.modal_correo&&
                <ModalCorreo
                    open={this.state.modal_correo}
                    toggle={this.toggle_correo}  
                    cliente={ticket.cliente_id} 
                    factura={this.state.factura}
                />
            }
             

				<EstadoModal
					open={this.state.modalEstado}
					toggle_estado={this.toggle_estado}
					ticketEstado={this.state.ticket}

				/>
                   {
                   	(this.state.rows.length>0&&parseInt(this.state.index)>=0&&this.state.modal_descripcion)&&
                   	<Modal isOpen={this.state.modal_descripcion} toggle={this.modal_descripcion} className="default modal-80">
				
                <ModalHeader toggle={this.modal_descripcion}>Descripción  del Producto</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-sm-11">
                            <div className="form-group">
                                <label htmlFor="">{parseInt(this.state.rows[parseInt( this.state.index)].producto.categoria_id)!==10?"Descripción":"Descripción  Servicio de:"}</label>
                                <input 
                                 type="text" 
                                 name="descripcion" 
                                 value={this.state.rows[parseInt( this.state.index)].descripcion}
                                 onChange={this.handleChangedescripcion} 
                                 className="form-control texto_normal" 
                                 maxLength={599}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label htmlFor="">Precio Lista</label>
                                <input 
                                 type="number"
                                 step="1"
                                 name="precio" 
                                 value={this.state.rows[parseInt( this.state.index)].precio}
                                 onChange={this.handleChangedescripcion} 
                                 className="form-control texto_normal" 
                                 />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label htmlFor="">Costo</label>
                                <input 
                                 type="number"
                                 step="1"
                                 name="costo" 
                                 value={this.state.rows[parseInt( this.state.index)].costo}
                                 onChange={this.handleChangedescripcion} 
                                 className="form-control texto_normal" 
                                 readOnly
                                 />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                         {
                            (!reset&&parseInt(rows[index].combo_id)>0)&&
                            <ArticulosCombo combo={this.state.modal_descripcion} 
                            combo={true}
                            reset={reset}
                            articulos={rows[index].combo} 
                            tipo={3} 
                            actualizar={this.actualizar_articulos} 
                            precio={rows[index].precio} />
                         }
                    </div>
                </ModalBody>
                <ModalFooter>
                    	<div>
                    		<Button color="success"  onClick={this.modal_descripcion} >
                    			&nbsp;Guardar
                    		</Button>{' '}
                    		<Button color="danger" onClick={this.modal_descripcion}>
		                    	Cancelar
		                    </Button>
                    	</div>
                </ModalFooter>
                
            </Modal>
                   }
				

						</CardBlock>
					</Card>
				</div>

			</div>
		)
	}

}

function mapStateToProps(state, ownProps) {
	return {
		ticket: state.ticket,
		auth:state.auth,
		notificciones:state.notificciones,
	}
};

export default connect(mapStateToProps, actions)(TicketForm)


/*

<Card>
                        <CardBlock>
                        <div className="text-right">
                                <Button color="success" className="mb-2" onClick={this.toggle}>
                                    Agregar
                                </Button>
                            </div>
                            <ReactTable
                              data      = {this.state.rows}
                              className = "-striped -highlight"
                              columns   = {[
                               
                                {Header: 'Total', accessor: 'total'},
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    Cell: (row) =>
                                    {
                                    	if((parseInt(ticket.pagado)===0)){
	                                        return(                                         

						                			<Button
						                			  color="danger"
						                			  outline
						                			 onClick={this.deleteRow.bind(this, row.index)}>
						                			  	X
						                			</Button>					                			
	                                        )
                                    	}else{
                                    		 return( " "  )
                                    	}
                                    }
                                }
                              
                              ]}
                              filterable 
                              defaultPageSize={10} 
                              
                             
                            />
                        </CardBlock>
                    </Card>



*/




// WEBPACK FOOTER //
// ./src/views/ticket/form.js